import {
    SET_QUOTE_DATA,
    MODAL_SHOW,
    MODAL_TYPE_ERROR,
    SALES_CHAT_LOADING_SCREEN_HIDE,
    SALES_CHAT_LOADING_SCREEN_SHOW,
    POLICY_LOAD_VIEW_SCREEN_SHOW,
    POLICY_LOAD_VIEW_SCREEN_HIDE,
    POLICY_VIEW_SUCCESS_SCREEN_HIDE,
    POLICY_VIEW_SUCCESS_SCREEN_SHOW,
    MODAL_HIDE,
    MODAL_TYPE_SUCCESS,
    SET_IVERI_DATA,
    PRODUCT_COMPREHENSIVE_CAR,
    SET_CART_DATA,
    NEW_QUOTE_CAR,
    UPDATE_POLICY_LOADER_SCREEN_SHOW,
    UPDATE_POLICY_LOADER_SCREEN_HIDE,
    UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW,
    UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE,
    SET_CUSTOMER_DATA,
    LOADING_SCREEN_HIDE,
    MODAL_TYPE_CHANGE_CREDIT_CARD,
    PRODUCT_PORTABLE_POSSESSIONS,
    PRODUCT_BLING,
    MODAL_TYPE_INTERVENTION,
    PORTABLE_COVER_TYPE,
    QUOTE_LOADING_SCREEN_HIDE,
    QUOTE_LOADING_SCREEN_SHOW,
    LOADING_SCREEN_SHOW,
    BLING_LIKE_NEW_COVER_TYPE,
    BLING_BRAND_NEW_COVER_TYPE,
    BLING_SCREEN_FIX_COVER_TYPE,
    PRODUCT_CODE_RED,
    SET_STEPS_CODE_RED,
    RESET_QUOTE_DATA,
    PRODUCT_CAR_WARRANTY,
    SET_STEPS_WARRANTY,
    COMPREHENSIVE_CAR_COVER_TYPE,
    AGREED_VALUE_COVER_TYPE,
    PRODUCT_BUILDING,
    PRODUCT_HOME_CONTENT,
    SET_STEPS_BUILDING,
    SET_STEPS_HOME_CONTENT,
    BUILDING_BORDER_FIELD_ID,
    BUILDING_BORDER_RIVER_ID,
    BUILDING_BORDER_INFORMAL_ID,
    BUILDING_BORDER_PLOT_ID,
    BUILDING_CLAIM_TYPE_ID,
    CONTENT_CLAIM_TYPE_ID,
    BUILDING_UNKNOWN_INSURER,
    SET_STEPS_BUILDING_PARTIAL,
    SET_STEPS_HOME_CONTENT_PARTIAL,
    ACTIVE_POLICY,
    CANCELLED_POLICY,
    MODAL_TYPE_OK,
} from "../constants/constants";
import { navigateTo } from './navigationActions';
import { CREDIT_HISTORY, CAR_REGISTRATION, VEHICLE_LOOKUP, SALES_ADDRESS, REGULAR_DRIVER, CAR_RISK, DRIVERS_LICENCE, QUOTATION, CLAIM_HISTORY, PERSONAL_INSURANCE, BANKING_DETAILS, CAR_DETAILS, GET_CAR_INSURANCE, GET_PORTABLE_POSSESSIONS_INSURANCE, PORTABLE_POSSESSIONS, ADD_REPLACEMENT_VALUE, PORTABLE_POSSESSIONS_CLAIM_HISTORY, GET_BLING_INSURANCE, GATHER_INFO, DASHBOARD, COVER_OPTIONS, GET_CODE_RED_INSURANCE, CART, GET_WARRANTY_QUOTATION, AGREED_VALUE_SELECT, GUESTSIGNUP, GET_BUILDING_QUOTATION, GET_HOME_CONTENT_QUOTATION, BUILDING_AND_CONTENT_JOURNEY_BUILDER } from "../routes/routes";
import { postToController, logErrorToDatabase } from "./apiActions";
import {CALL_ASAP, CALL_BACK_REQUEST, ERROR_HEADER, ERROR_SOMETHING_WENT_WRONG} from "../constants/copy";
import {postPolicyCreation, postPolicyUpdate, requestOTP} from "./authActions";
import { showCallMeModal, showHardRejectedModal, showSoftRejectedModal, showCoverRemovedModal, showRetentionsModal, showRetentionsWithDependentsModal, showRemoveReasons, showEstimatedTimeForEachStep, showModalExistingClient } from "./modalActions";
import { adminJudgementAnswer, AdminJudgementAnswerSet, AdminJudgementQuestion, secondaryAdminJudgementAnswer } from "../interfaces/Legal/legalInterfaces";
import { callMeBack } from "./profileActions";
import { discardCart, discardCartCollectable, discardCartPortable } from "./cartActions";
import { AMEND_POLICY_BLING, AMEND_POLICY_CAR, AMEND_POLICY_PORTABLE, BUILDING_COMPREHENSIVE_PRODUCT_GUID, CODE_RED_PRODUCT_GUID, HOME_CONTENT_COMPREHENSIVE_PRODUCT_GUID } from "../constants/products";
import { logEvent } from '../firebase/firebase';
import { ICancelQuoteCover, IClaimsAddress, IPropertyBorders } from "../interfaces/Sales/salesInterfaces";
import { isMobile } from "react-device-detect";
import { NAM_COUNTRY_ID_NUMBER, SA_COUNTRY_ID_NUMBER } from "../constants/internationalization";
import {showModalCalculatorBroke} from "./salesModalActions";

export const IveriSubmission = (quoteId: string) => {
    return async (dispatch) => {
        await postToController(dispatch, 'IveriSubmission',
            JSON.stringify({
                QuoteId: quoteId,
            }))
            .then(async response => {
                await dispatch({
                    type: SET_IVERI_DATA, payload: response
                });
            })
            .catch(err => logErrorToDatabase("Iveri Submission Error: " + err))
    }
}

export const setData = (type: string, name: string, value: any) => {
    return (dispatch, getState) => {
        dispatch({
            type: type, payload: {
                [name]: value
            }
        });
    }
}

export const setQuoteData = (payload) => {
    return (dispatch, getState) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: payload
        });
    }
}

export const resetQuoteData = () => {
    return async (dispatch) => {
        await dispatch({ type: RESET_QUOTE_DATA });
    }
}

export const setPersonalInfo = (Name: string, Surname: string, Phone: string, Email: string) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                name: Name,
                surname: Surname,
                cellphoneNumber: Phone,
                email: Email,
            }
        });

        if (getState().profile.name === "") {
            dispatch({
                type: SET_CUSTOMER_DATA, payload: {
                    name: Name,
                    surname: Surname,
                    cellphoneNumber: Phone,
                    email: Email,
                }
            });
        }
        dispatch({ type: SALES_CHAT_LOADING_SCREEN_SHOW });

        await postToController(dispatch, 'CreateWebLead', JSON.stringify({
            Email: "",
            ContactNumber: "",
            MobileNumber: getState().sales.cellphoneNumber,
            IdNumber: "",
            FirstName: getState().sales.name,
            Kpcid: getState().profile.countryId == NAM_COUNTRY_ID_NUMBER ? "100097" : "10005",
            Comments: "New quote lead from SSP",
            CountryId: getState().profile.countryId,
            Status: "CLOSED"
        })).then(async (response) => {
            if (response !== null && response !== 'Failure') {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        bucketKey: response.bucketKey,
                    }
                });
            }
        }).finally(() => {
            dispatch({ type: SALES_CHAT_LOADING_SCREEN_HIDE });
        });

        if (getState().sales.quoteType === PRODUCT_BLING) {
            dispatch(navigateTo(SALES_ADDRESS))
        }
        else {
            dispatch(navigateTo(CREDIT_HISTORY));
        }
    }
}

export const setFinanceHouse = (FinanceHouse: string, FinanceHouseId: number) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                financeHouse: FinanceHouse,
                financeHouseId: FinanceHouseId,
            }
        });
    }
}

export const setCarDetails = (VehicleYear: number, MakeId: number, ModelId: number, SeriesId: number, MmCode: string, Description: string) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                vehicleYear: VehicleYear,
                vehicleMakeId: MakeId,
                vehicleModelId: ModelId,
                vehicleSeriesId: SeriesId,
                vehicleFullDescription: Description,
                mmCode: MmCode,
            }
        });
        dispatch(navigateTo(SALES_ADDRESS));
    }
}

export const setLicenceData = (LicenceDate: string, LicenceCode: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                driversLicenseDate: LicenceDate,
                driversLicense: LicenceCode,
            }
        });
        if (getState().cart.quoteId && getState().sales.carRisk !== "" && getState().sales.carRisk !== undefined) {
            await dispatch(addCarToQuote());
        }
        else {
            dispatch(navigateTo(CAR_RISK));
        }
    }
}

export const setMaritalStatus = (MaritalStatus: string) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                maritalStatus: MaritalStatus,
            }
        });
    }
}

export const setLastClaim = (LastClaim: any) => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_QUOTE_DATA, payload: {
                lastClaim: LastClaim,
                isNewItem: true
            }
        });
        await dispatch(addCarToQuote());
    }
}

export const setCarRisk = (CarRisk: any) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                carRisk: CarRisk,
            }
        });
        dispatch(navigateTo(CLAIM_HISTORY));
    }
}

export const setParkAddress = (Lat: string, Lng: string, Address: string, AddressDetail: any) => {
    return (dispatch, getState) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                address: Address,
                addressDetail: AddressDetail,
                lat: Lat,
                lon: Lng,
            }
        });
        if (getState().sales.quoteType === PRODUCT_BLING) {
            dispatch(navigateTo(CREDIT_HISTORY));
        }
        else {
            dispatch(navigateTo(REGULAR_DRIVER));
        }
    }
}

export const setLegalQuestions = (CriminalOffence: string, SpecialTerms: string, Refused: string, Advised: string, Cancelled: string) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                criminaloffence: CriminalOffence,
                specialterms: SpecialTerms,
                refused: Refused,
                advised: Advised,
                cancelled: Cancelled
            }
        });
    }
}

export const setIsInEdit = (value: boolean) => {
    if (value) {
        return (dispatch) => {
            dispatch({
                type: SET_QUOTE_DATA, payload: {
                    isInEdit: value,
                }
            });
        }
    } else {
        return (dispatch) => {
            dispatch({
                type: SET_QUOTE_DATA, payload: {
                    isInEdit: false,
                }
            });
        }
    }

}

export const setIsInEditRemove = (value: boolean) => {
    if (value) {
        return (dispatch) => {
            dispatch({
                type: SET_QUOTE_DATA, payload: {
                    isInRemove: value,
                }
            });
        }
    } else {
        return (dispatch) => {
            dispatch({
                type: SET_QUOTE_DATA, payload: {
                    isInRemove: false,
                }
            });
        }
    }

}

export const toggleRaf = (value: any) => {

    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                rafAssist: value,
                hadRafAssist: value.isActive,
            }
        });
    }
}

export const createQuoteFromPolicy = () => {
    return async (dispatch, getState) => {
        dispatch({ type: SALES_CHAT_LOADING_SCREEN_SHOW });
        var request = JSON.stringify({
            PolicyId: getState().profile.policyId,
        });
        logEvent('SSP_create_quote_from_policy', getState().profile.policyId);
        await postToController(dispatch, 'CreateQuoteFromPolicy', request).then(async (response) => {
            if (response == null || response === "Failure" || response === "" || response.success === false ) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                dispatch(navigateTo(DASHBOARD));
            } else {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        quoteId: response.quoteId,
                        customerId: response.customerId,
                        quoteNumber: response.quoteNumber
                    }
                });

                if (response.regularDriver !== null) {
                    await postToController(dispatch, 'GetDriversLicenceSelection', JSON.stringify({})).then(async (licenceList) => {
                        var licence = {}
                        for (var i = 0; i < licenceList.length; i++) {
                            if (licenceList[i].description === response.regularDriver.licenseCode.code) {
                                licence = licenceList[i];
                                break;
                            }
                        }
                        await dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                driversLicense: licence,
                            }
                        });
                    })
                    await dispatch({
                        type: SET_QUOTE_DATA, payload: {
                            driversLicenseDate: response.regularDriver.licenseIssueDate,
                            lastClaim: response.regularDriver.lastAccidentClaim,
                            carRisk: response.regularDriver.insuranceDuration,
                        }
                    });
                }
                if (getState().sales.quoteType !== PRODUCT_PORTABLE_POSSESSIONS && getState().sales.quoteType !== PRODUCT_BLING)
                    dispatch(navigateTo(CAR_REGISTRATION));
            }
        }).catch(err => {
            logErrorToDatabase("Unable to create policy, Error: " + err)
        });
        dispatch({ type: SALES_CHAT_LOADING_SCREEN_HIDE });
    }
}

export const createQuoteFromPolicyCardUpdate = () => {
    return async (dispatch, getState) => {
        var request = JSON.stringify({
            PolicyId: getState().profile.policyId,
        });

        await postToController(dispatch, 'IveriSubmission',
            JSON.stringify({
                QuoteId: getState().profile.policyId,
            }))
            .then(async response => {
                await dispatch({
                    type: SET_IVERI_DATA, payload: response
                });
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_CHANGE_CREDIT_CARD,
                    }
                });
            })
            .catch(err => logErrorToDatabase("Iveri Submission Error: " + err))
    }
}


export const createPolicy = () => {
    return async (dispatch, getState) => {
        let request = "";
        if (getState().auth.provider === "anon") {
            request = JSON.stringify({
                QuoteId: getState().sales.quoteId,
                LinkMobile: false,
                UpdateQuote: {
                    QuoteId: getState().sales.quoteId,
                    SalaryDay: getState().sales.debitOrderDate.id,
                    DebitOrderDay: getState().sales.debitOrderDate.id,
                },
                AcceptQuote: {
                    QuoteId: getState().sales.quoteId,
                },
                UserProfile: { Email: getState().sales.email, }
            });
        }
        else {
            request = JSON.stringify({
                QuoteId: getState().sales.quoteId,
                LinkMobile: true,
                UpdateQuote: {
                    QuoteId: getState().sales.quoteId,
                    SalaryDay: getState().sales.debitOrderDate.id,
                    DebitOrderDay: getState().sales.debitOrderDate.id,
                },
                AcceptQuote: {
                    QuoteId: getState().sales.quoteId,
                },
                UserProfile: {
                    Email: getState().sales.email,
                    UserId: getState().firebase.auth.uid,
                    Name: getState().sales.name,
                    LastName: getState().sales.surname,
                    FullName: getState().sales.name + ' ' + getState().sales.surname,
                    Gender: getState().profile.gender,
                    MobileLoginType: 3,
                }
            });
        }
        logEvent('SSP_create_policy_from_quote', getState().sales.quoteId);
        await postToController(dispatch, 'CreatePolicy', request).then(async (response) => {
            if (response === "Failure") {
                await dispatch(navigateTo(DASHBOARD))
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_INTERVENTION,
                    }
                });
                dispatch({ type: POLICY_LOAD_VIEW_SCREEN_HIDE });
            }
            else {
                if (getState().auth.provider === "anon") {
                    dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            policyId: response.policyId,
                            guestPolicyNumber: response.policyNumber,
                        }
                    });
                    dispatch(navigateTo(GUESTSIGNUP))
                }
                else {
                    dispatch(navigateTo(DASHBOARD))
                    if (getState().sales.email.toLowerCase().includes("@kingprice.dev")) {
                        response.policyNumber = response.policyNumber.replace("KP", "KPT");
                    }
                    dispatch(requestOTP(response.policyNumber));
                }
            }
        }).catch(err => {
            logErrorToDatabase("Unable to create policy, Error: " + err)
            dispatch(navigateTo(DASHBOARD))
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_INTERVENTION,
                }
            });
        });
        await dispatch({ type: RESET_QUOTE_DATA})
        await dispatch({ type: POLICY_LOAD_VIEW_SCREEN_HIDE });
        await dispatch({ type: LOADING_SCREEN_HIDE });
    }
}

export const updatePolicy = (skipLoadingScreenShow = false) => {
    return async (dispatch, getState) => {
        var request = JSON.stringify({
            QuoteId: getState().sales.quoteId,
            PolicyId: getState().profile.policyId,
        });
        if (!skipLoadingScreenShow) { await dispatch({ type: POLICY_LOAD_VIEW_SCREEN_SHOW }); }
        logEvent('SSP_update_policy', getState().sales.quoteId + '/' + getState().profile.policyId);
        await postToController(dispatch, 'UpdatePolicy', request).then(async (response) => {
            if (response === "Failure") {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            } else {
                dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
                await postPolicyUpdate(dispatch, getState, getState().profile.email);
                await dispatch(navigateTo(PERSONAL_INSURANCE));
            }
        }).catch(err => {
            logErrorToDatabase("Unable to create policy, Error: " + err)
        });
        if (!skipLoadingScreenShow) { await dispatch({ type: POLICY_LOAD_VIEW_SCREEN_HIDE }); }
    }
}

export const updateCreditCard = () => {
    return async (dispatch, getState) => {
        var request = JSON.stringify({
            QuoteId: getState().sales.quoteId,
            PolicyId: getState().profile.policyId,
        });
        logEvent('SSP_update_policy', getState().sales.quoteId + '/' + getState().profile.policyId);
        await postToController(dispatch, 'UpdatePolicy', request).then(async (response) => {
            if (response === "Failure") {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            } else {
                dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
            }
        }).catch(err => {
            logErrorToDatabase("Unable to create policy, Error: " + err)
        });
    }
}

export const newMobileClientCheck = (IdNumber: string, Consent: boolean, isMale: any) => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_QUOTE_DATA, payload: {
                idNumber: IdNumber,
                itcConsent: Consent,
            }
        });
        if (getState().profile.policyId === "") {
            dispatch({ type: SALES_CHAT_LOADING_SCREEN_SHOW });
            logEvent('SSP_new_client_check', {});
            await postToController(dispatch, 'NewMobileClientCheck', JSON.stringify({
                Email: getState().sales.email,
                CellphoneNumber: getState().sales.cellphoneNumber,
                IdNumber: IdNumber,
                Name: getState().sales.name,
                Surname: getState().sales.surname,
                ItcConsent: Consent,
                CountryId: getState().profile.countryId,
                AddressLine: getState().sales.address,
                Latitude: getState().sales.lat,
                Longtitude: getState().sales.lon,
                IsMale: getState().profile.countryId !== NAM_COUNTRY_ID_NUMBER ? null : isMale,
                LmsBucketKey: getState().sales.bucketKey
            })).then(async (response) => {
                if (response !== null && response !== 'Failure') {
                    if (response.mobileClientInfoStatus === ACTIVE_POLICY || response.mobileClientInfoStatus === CANCELLED_POLICY) {
                        dispatch(showModalExistingClient());
                        await dispatch(navigateTo(DASHBOARD));
                    } else if (response.quoteId === '00000000-0000-0000-0000-000000000000') {
                        logErrorToDatabase("NewMobileClientCheck returned an empty response for client with ID number: " + IdNumber);
                        dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        });
                        await dispatch(navigateTo(DASHBOARD));
                    }
                    else {
                        dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                mobileClientInfoStatus: response.mobileClientInfoStatus,
                                policyId: response.policyId,
                                quoteId: response.quoteId,
                                customerId: response.customerId,
                                quoteNumber: response.quoteNumber,
                                policyNumber: response.policyNumber,
                                lmsStatus: response.lmsStatus,
                                bucketKey: response.bucketKey,
                                idNumber: IdNumber,
                            }
                        });
                        if (getState().sales.quoteType !== PRODUCT_PORTABLE_POSSESSIONS && getState().sales.quoteType !== PRODUCT_BLING)
                            dispatch(navigateTo(CAR_REGISTRATION));
                    }
                }
                else {
                    logErrorToDatabase("NewMobileClientCheck returned an empty response for client with ID number: " + IdNumber);
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    });
                    await dispatch(navigateTo(DASHBOARD));
                }
            }).catch((err) => {
                logErrorToDatabase("Error in creditHistoryCheck: " + err);
            }).finally(() => {
                dispatch({ type: SALES_CHAT_LOADING_SCREEN_HIDE });
            })
        } else {
            dispatch({
                type: SET_QUOTE_DATA, payload: {
                    cellphoneNumber: getState().profile.cellphoneNumber,
                    email: getState().profile.email,
                    idNumber: getState().profile.idNumber,
                    name: getState().profile.name,
                    surname: getState().profile.surname,
                }
            });
            dispatch(createQuoteFromPolicy());
        }
    }
}

export const newMobileClientCheckNewJourney = (IdNumber: string, Consent: boolean, isMale: any) => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_QUOTE_DATA, payload: {
                idNumber: IdNumber,
                itcConsent: Consent,
            }
        });
        dispatch({ type: SALES_CHAT_LOADING_SCREEN_SHOW });
        logEvent('SSP_new_client_check', {});
        await postToController(dispatch, 'NewMobileClientCheck', JSON.stringify({
            Email: getState().sales.email,
            CellphoneNumber: getState().sales.cellphoneNumber,
            IdNumber: IdNumber,
            Name: getState().sales.name,
            Surname: getState().sales.surname,
            ItcConsent: Consent,
            CountryId: getState().profile.countryId,
            AddressLine: getState().sales.address,
            Latitude: getState().sales.lat,
            Longtitude: getState().sales.lon,
            IsMale: getState().profile.countryId !== 157 ? null : isMale,
            LmsBucketKey: getState().sales.bucketKey
        })).then(async (response) => {
            if (response !== null && response.mobileClientInfoStatus === ACTIVE_POLICY || response.mobileClientInfoStatus === CANCELLED_POLICY) {
                dispatch(showModalExistingClient());
                await dispatch(navigateTo(DASHBOARD));
            }
            else if (response !== null && response.quoteId !== '00000000-0000-0000-0000-000000000000' && response !== 'Failure') {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        mobileClientInfoStatus: response.mobileClientInfoStatus,
                        policyId: response.policyId,
                        quoteId: response.quoteId,
                        customerId: response.customerId,
                        quoteNumber: response.quoteNumber,
                        policyNumber: response.policyNumber,
                        lmsStatus: response.lmsStatus,
                        bucketKey: response.bucketKey,
                        idNumber: IdNumber,
                    }
                });
            }
            else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                await dispatch(navigateTo(DASHBOARD));
            }
          }).finally(() => {
            dispatch({ type: SALES_CHAT_LOADING_SCREEN_HIDE });
        })
    }
}

export const setQuoteType = (quoteName: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                quoteType: quoteName,
            }
        })
    }
}

export const CarRegistrationCheck = (regNr: any, successCallback: any = null, failCallback: any = null) => {
    return async (dispatch, getState) => {
        dispatch({ type: SALES_CHAT_LOADING_SCREEN_SHOW });
        await dispatch({
            type: SET_QUOTE_DATA, payload: {
                regNr: regNr,
            }
        });
        await postToController(dispatch, 'VehicleLookup', JSON.stringify({
            VehicleRegistrationNumber: regNr,
        })).then(async (response) => {
            if (response !== null) {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        vehicleFullDescription: response.fullDescription,
                        vehicleYear: response.vehicleYear.registrationYear,
                        vehicleMakeId: response.vehicleMake.id,
                        vehicleModelId: response.vehicleModel.id,
                        vehicleSeriesId: response.vehicleSeries.id,
                        mmCode: response.vehicleSeries.mmCode,
                        regNr: regNr
                    }
                });
                if (successCallback != null) {
                    dispatch(successCallback(response));
                }
                else {
                    dispatch(navigateTo(VEHICLE_LOOKUP));
                }
            } else {
                logErrorToDatabase("Unable to get transunion data for vehicle: " + regNr);
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        vehicleFullDescription: "",
                        vehicleYear: "",
                        vehicleMakeId: "",
                        vehicleModelId: "",
                        vehicleSeriesId: "",
                        mmCode: "",
                        regNr: regNr
                    }
                });
                if (failCallback != null) {
                    dispatch(failCallback(response));
                }
                else {
                    dispatch(navigateTo(CAR_DETAILS));
                }
            }
        }).catch((err) => {
            logErrorToDatabase("Error VehicleLookup, Error: " + err);

        }).finally(() => {
            dispatch({ type: SALES_CHAT_LOADING_SCREEN_HIDE });
        })
    }
}

export const postRegularDriverFlow = () => {
    return async (dispatch, getState) => {
        if (getState() && getState().sales && getState().sales.selectedDriver && getState().sales.selectedDriver.toLowerCase() === "someone else") {
            dispatch(navigateTo(DRIVERS_LICENCE))
        }
        else if (getState().profile.policyId !== "" && getState().sales.driversLicense !== "" && getState().sales.driversLicense !== undefined) {
            await dispatch(addCarToQuote())
        } else {
            dispatch(navigateTo(DRIVERS_LICENCE)) // redirect to MARITAL_STATUS and call this method from RegularDriver/RegularDriverOther once figured out how to prepop marital status from policy
        }
    }
}

export const setRegularDriver = (RegularDriver: string) => {
    return (dispatch, getState) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                regularDriver: RegularDriver,
                regularDriverOtherName: getState().sales.name,
                regularDriverOtherSurname: getState().sales.surname,
                regularDriverOtherIdNumber: getState().sales.idNumber,
                regularDriverRelationship: RegularDriver,
            }
        });
    }
}

export const setRegularDriverOther = (Name: string, Surname: string, IdNumber: string, Relationship: string, isMale: any) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                regularDriver: Relationship,
                regularDriverOtherName: Name,
                regularDriverOtherSurname: Surname,
                regularDriverOtherIdNumber: IdNumber,
                regularDriverRelationship: Relationship,
                regularDriverGender: isMale
            }
        });
    }
}

export const setSelectedDriver = (Description: string) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                selectedDriver: Description,
            }
        });
    }
}

export const addCarToQuote = () => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        var success = true;
        var collectable = false;
        var premuimError = false;
        logEvent('SSP_add_car_to_quote', getState().sales.quoteId);
        await postToController(dispatch, 'AddCarToQuote', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            PolicyId: getState().profile.policyId,
            AddressLine: getState().sales.address,
            AddressLat: getState().sales.lat.toString(),
            AddressLon: getState().sales.lon.toString(),
            AddressSuburb: getState().sales.addressDetail.suburb,
            AddressProvince: getState().sales.addressDetail.province,
            AddressCity: getState().sales.addressDetail.city,
            AddressPostalCode: getState().sales.addressDetail.postalCode,
            Product: 1,
            ContactNumber: getState().sales.cellphoneNumber,
            Email: getState().sales.email,
            FirstName: getState().sales.name,
            Surname: getState().sales.surname,
            IdNumber: getState().sales.idNumber,
            SelectedMaritalStatus: getState().sales.maritalStatus.id,
            LicenseCode: getState().sales.driversLicense.id,
            LicenseDate: getState().sales.driversLicenseDate,
            InsuranceDuration: getState().sales.carRisk.id.toString(),
            LastClaimId: getState().sales.lastClaim.id.toString(),
            VehicleYear: getState().sales.vehicleYear.toString(),
            VehicleMakeId: getState().sales.vehicleMakeId.toString(),
            VehicleModelId: getState().sales.vehicleModelId.toString(),
            VehicleSeriesId: getState().sales.vehicleSeriesId.toString(),
            MmCode: getState().sales.mmCode,
            RegularDriverFirstName: getState().sales.regularDriverOtherName,
            RegularDriverSurname: getState().sales.regularDriverOtherSurname,
            RegularDriverIdNumber: getState().sales.regularDriverOtherIdNumber,
            RegularDriverGender: getState().profile.countryId === 244 ? null : getState().sales.regularDriverGender,
            RegularDriverRelationship: getState().sales.regularDriverRelationship === undefined ? "0" : getState().sales.regularDriverRelationship.id.toString(),
            AvgKilometersTravelled: 0,
            TotalKilometersTravelled: 0,
            InstallTrackingDevice: "No",
            TrackerId: 0,
            FinanceHouseId: getState().sales.financeHouseId,
            RegistrationNumber: getState().sales.regNr,
            CountryId: getState().profile.countryId,
        })).then(async (response) => {
            if (response !== "Failure" && response !== null) {
                await postToController(dispatch, 'GetCarDetails', JSON.stringify({
                    QuoteId: response.quoteId,
                    QuoteRiskItemId: response.carId,
                    RiskItemId: response.carId,
                })).then(async (carDetailsResponse) => {
                    if (carDetailsResponse.premiumError){
                        success = false;
                        premuimError = true;
                        dispatch(showModalCalculatorBroke());
                    }
                    else {
                        if (carDetailsResponse.carDetails.carDetails.retailValue <= 10000) {
                            collectable = true;
                            success = false;
                            await dispatch({type: POLICY_LOAD_VIEW_SCREEN_SHOW});
                            await dispatch(discardCartCollectable());
                            await dispatch(callMeBack(getState().sales.name + " " + getState().sales.surname, getState().sales.cellphoneNumber, "Collectable car", null));
                            return;
                        }
                        await postToController(dispatch, 'GetExcessSelection', JSON.stringify({
                            Excess: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                            ExcessId: carDetailsResponse.carDetails.carDetails.excessDetails.excessId,
                            ExcessOptions: carDetailsResponse.carDetails.carDetails.excessDetails.excessOptions,
                        })).then(async (excessResponse) => {
                            await postToController(dispatch, 'GetVapOptions', JSON.stringify({
                                Parameter: getState().profile.countryId,
                            })).then(async (vapOptions) => {
                                await dispatch({
                                    type: SET_QUOTE_DATA, payload: {
                                        coverId: response.coverId,
                                        carPremium: carDetailsResponse.carDetails.carDetails.premium.toFixed(2),
                                        proRata: response.proRata,
                                        quote: response,
                                        excessList: excessResponse,
                                        selectedExcess: {
                                            description: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                                            id: carDetailsResponse.carDetails.carDetails.excessDetails.excessId
                                        },
                                        carId: response.carId,
                                        carDetails: carDetailsResponse.carDetails.carDetails,
                                        tyreAndRimOptions: vapOptions.tyreAndRim,
                                        littleDingsOptions: vapOptions.littleDingsAndTyreThings,
                                        carHireOptions: vapOptions.carHire,
                                        balloonOptions: vapOptions.baloonPercentage,
                                        isNewItem: true,
                                        totalPremium: carDetailsResponse.totalPremium
                                    },
                                });
                            }).catch(err => {
                                success = false;
                                logErrorToDatabase("Error GetVapOptions in salesActions: " + err);
                            })
                        }).catch(err => {
                            success = false;
                            logErrorToDatabase("Error GetExcessSelection in salesActions: " + err);
                        })
                    }
                }).catch(err => {
                    success = false;
                    logErrorToDatabase("Error GetCarDetails in salesActions: " + err);
                })
            } else {
                success = false;
                logErrorToDatabase("Error adding car to quote in salesActions");
            }
        }).catch((err) => {
            logErrorToDatabase("Error adding car to quote, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            if (success) {
                if (getState().ssp.agreedValueEnabled && getState().profile.countryId === SA_COUNTRY_ID_NUMBER) {
                    dispatch(navigateTo(AGREED_VALUE_SELECT));
                    dispatch({
                        type: SET_QUOTE_DATA, payload: {
                            isQuoteScreen: true,
                        }
                    });
                }
                else {
                    dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_SHOW });
                    setTimeout(() => {
                        dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_HIDE });
                        dispatch(navigateTo(QUOTATION))
                        dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                isQuoteScreen: true,
                            }
                        });
                    }, 1000);
                }
            } else if (!premuimError && !collectable) {
                dispatch(navigateTo(GET_CAR_INSURANCE));
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        })
    }
}

export const addProduct = (product) => {
    return async (dispatch, getState) => {
        if (product === PRODUCT_COMPREHENSIVE_CAR) {
            if (!getState().cart.quoteId) {
                await dispatch({ type: RESET_QUOTE_DATA });
                await dispatch(navigateTo(GET_CAR_INSURANCE));
                await dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
            }
            else {
                await dispatch({
                    type: NEW_QUOTE_CAR
                });
                await dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
                if (getState().sales.quoteType !== PRODUCT_PORTABLE_POSSESSIONS) //check if its portable possessions - quoteType
                    dispatch(navigateTo(CAR_REGISTRATION));
            }
        }
        else if (product === PRODUCT_PORTABLE_POSSESSIONS) {
            if (!getState().cart.quoteId) {
                await dispatch({ type: RESET_QUOTE_DATA });
                await dispatch(navigateTo(GET_PORTABLE_POSSESSIONS_INSURANCE));
                await dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
            }
            else {
                await dispatch({
                    type: NEW_QUOTE_CAR
                });
                await dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });

                dispatch(navigateTo(PORTABLE_POSSESSIONS));
            }
        }
        else if (product === PRODUCT_BLING) {
            if (!getState().cart.quoteId) {
                await dispatch({ type: RESET_QUOTE_DATA });
                await dispatch(navigateTo(GET_BLING_INSURANCE));
                await dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
            }
            else {
                await dispatch({
                    type: NEW_QUOTE_CAR
                });
                await dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });

                dispatch(navigateTo(GATHER_INFO));
            }
        }
        else if (product === PRODUCT_CODE_RED) {
            if (!getState().cart.quoteId) {
                await dispatch({ type: RESET_QUOTE_DATA });
                await dispatch(navigateTo(GET_CODE_RED_INSURANCE));
                await dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
            }
            else {
                await dispatch({
                    type: PRODUCT_CODE_RED
                });
                await dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
                await dispatch(navigateTo(GET_CODE_RED_INSURANCE));
            }
        }
        else if (product === PRODUCT_CAR_WARRANTY && getState().ssp.salesWarrantyEnabled) {
            if (!getState().cart.quoteId) {
                await dispatch({ type: RESET_QUOTE_DATA });
                await dispatch(navigateTo(GET_WARRANTY_QUOTATION));
                await dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
            }
            else {
                await dispatch({
                    type: PRODUCT_CODE_RED
                });
                await dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
                await dispatch(navigateTo(GET_WARRANTY_QUOTATION));
            }
        }
        else if ((product === PRODUCT_BUILDING || product === PRODUCT_HOME_CONTENT) && getState().ssp.salesBuildingAndContentEnabled) {
            let targetLocation = GET_BUILDING_QUOTATION;
            if (product === PRODUCT_HOME_CONTENT) {
                targetLocation = GET_HOME_CONTENT_QUOTATION;
            }

            if (!getState().cart.quoteId) {
                await dispatch({ type: RESET_QUOTE_DATA });
                await dispatch(navigateTo(targetLocation));
                await dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
            }
            else {
                await dispatch({ type: SET_QUOTE_DATA, payload: { addProduct: product } });
                await dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
                await dispatch(navigateTo(targetLocation));
            }
        }
        else {
            if (getState().profile.isLinked) {
                dispatch(showCallMeModal(true))
            }
            else {
                window.open("https://kingprice.co.za/Home/QuoteIndex", '_blank');
            }
        }
    }
}

export const updateExcess = (selectedExcess: any) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        logEvent('SSP_update_quote_excess', getState().sales.quoteId + "/" + getState().sales.coverId);
        await postToController(dispatch, 'UpdateQouteExcess', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            CoverId: getState().sales.coverId,
            QuoteRiskItemId: getState().sales.carId,
            ExcessItemId: parseInt(selectedExcess.id),
            ExcessValue: selectedExcess.description.toString(),
        })).then(async (response) => {
            if (response !== null && response !== "Failure") {
                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        carPremium: response.riskItemPremium,
                        selectedExcess: {
                            description: selectedExcess.description.replace("R", ""),
                            id: selectedExcess.id
                        },
                        totalPremium: response.grossPremium,
                        proRata: response.proRata,
                    }
                });

            } else {
                logErrorToDatabase("Error updating excess options in salesActions");
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        isInEdit: false,
                    }
                });
                dispatch(navigateTo(DASHBOARD));
            }
        }).catch((err) => {
            logErrorToDatabase("Error updating excess on quote, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
            dispatch({
                type: SET_QUOTE_DATA, payload: {
                    isInEdit: false,
                }
            });
            dispatch(navigateTo(DASHBOARD));
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
            setTimeout(() => {
                dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
            }, 1000);
        })
    }
}

export const addVapToQuote = (selectedVap: any, productCode: string) => {
    return async (dispatch, getState) => {
        logEvent('SSP_add_vap_quote', getState().sales.quoteId + '/' + selectedVap);
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        await postToController(dispatch, 'AddVapsCoverToQuote', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            CoverId: getState().sales.coverId,
            SelectedVap: selectedVap.id,
            ProductCode: productCode
        })).then(async (response) => {
            await dispatch({
                type: MODAL_HIDE,
                modalProps: {
                    type: MODAL_TYPE_SUCCESS,
                    visible: false,
                }
            });
            if (response !== null && response !== "Failure") {
                await postToController(dispatch, 'GetCarDetails', JSON.stringify({
                    QuoteId: getState().sales.quoteId,
                    RiskItemId: getState().sales.carId,
                    QuoteRiskItemId: getState().sales.carId
                })).then(async (carDetailsResponse) => {
                    if (carDetailsResponse.premiumError){
                        dispatch(showModalCalculatorBroke());
                    }
                    else {
                        await dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                carDetails: carDetailsResponse.carDetails.carDetails,
                                carPremium: carDetailsResponse.carDetails.carDetails.premium.toFixed(2).toString(),
                                quote: response.quote,
                                proRata: response.proRata,
                                totalPremium: carDetailsResponse.totalPremium
                            },
                        });
                    }
                });
            }
            else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        isInEdit: false,
                    }
                });
                dispatch(navigateTo(DASHBOARD));
            }
        }).catch((err) => {
            logErrorToDatabase("Error adding vaps to quote, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
            setTimeout(() => {
                dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
            }, 1000);
        })
    }
}

export const editVapCoverOnQuote = (selectedVap: any, productCode: string) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        logEvent('SSP_update_vap_quote', getState().sales.quoteId + '/' + selectedVap);
        await postToController(dispatch, 'UpdateVapCoverOnQuote', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            CoverId: getState().sales.coverId,
            SelectedVap: selectedVap.quoteCoverId,
            ProductCode: productCode
        })).then(async (response) => {
            dispatch({
                type: MODAL_HIDE,
                modalProps: {
                    type: MODAL_TYPE_SUCCESS,
                    visible: false,
                }
            });
            if (response !== null && response !== "Failure") {
                await postToController(dispatch, 'GetCarDetails', JSON.stringify({
                    QuoteId: getState().sales.quoteId,
                    QuoteRiskItemId: getState().sales.carId,
                    RiskItemId: getState().sales.carId,
                })).then(async (carDetailsResponse) => {
                    if (carDetailsResponse.premiumError){
                        dispatch(showModalCalculatorBroke());
                    }
                    else {
                        dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                carDetails: carDetailsResponse.carDetails.carDetails,
                                carPremium: carDetailsResponse.carDetails.carDetails.premium.toFixed(2).toString(),
                                quote: response.quote,
                                proRata: response.proRata,
                                totalPremium: carDetailsResponse.totalPremium
                            },
                        });
                    }
                })
            }
            else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        isInEdit: false,
                    }
                });
                dispatch(navigateTo(DASHBOARD));
            }
        }).catch((err) => {
            logErrorToDatabase("Error updating vaps on quote, Error: " + err);
        }).finally(() => {

            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
            setTimeout(() => {
                dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
            }, 1000);
        })
    }
}

export const RemoveVapCoverOnQuote = (selectedVap: any) => {
    return async (dispatch, getState) => {
        if (selectedVap.reasonRequired) {
            await dispatch({
                type: SET_QUOTE_DATA, payload: {
                    primaryQuoteCancellationReason: undefined,
                    secondaryQuoteCancellationReason: undefined,
                }
            });
            await dispatch(showRemoveReasons(selectedVap))
        }
        else {
            dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
            logEvent('SSP_remove_vap_quote', getState().sales.quoteId + '/' + selectedVap);
            await postToController(dispatch, 'RemoveVapCoverOnQuote', JSON.stringify({
                QuoteId: getState().sales.quoteId,
                CoverId: getState().sales.coverId,
                SelectedVap: selectedVap.quoteCoverId,
                ProductCode: "A"
            })).then(async (response) => {
                await dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
                if (response !== null && response !== "Failure") {
                    await postToController(dispatch, 'GetCarDetails', JSON.stringify({
                        QuoteId: getState().sales.quoteId,
                        QuoteRiskItemId: getState().sales.carId,
                        RiskItemId: getState().sales.carId,
                    })).then(async (carDetailsResponse) => {
                        if (carDetailsResponse.premiumError){
                            dispatch(showModalCalculatorBroke());
                        }
                        else {
                            dispatch({
                                type: SET_QUOTE_DATA, payload: {
                                    carDetails: carDetailsResponse.carDetails.carDetails,
                                    carPremium: carDetailsResponse.carDetails.carDetails.premium.toFixed(2).toString(),
                                    quote: response.quote,
                                    proRata: response.proRata,
                                    totalPremium: carDetailsResponse.totalPremium
                                },
                            });
                        }
                    })
                }
                else {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    });
                    dispatch({
                        type: SET_QUOTE_DATA, payload: {
                            isInEdit: false,
                        }
                    });
                    dispatch(navigateTo(DASHBOARD));
                }
            }).catch((err) => {
                logErrorToDatabase("Error removing vap on quote, Error: " + err);
            }).finally(() => {

                dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
                dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
                }, 1000);
            })
        }
    }
}

export const addAccessoryToQoute = (selectedAccessory: any, replacementValue: string) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        logEvent('SSP_add_accessory_to_quote', getState().sales.quoteId + '/' + getState().profile.policyId);
        await postToController(dispatch, 'AddAccessoryToQuote', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            CoverId: getState().sales.carId,
            SelectedAccessory: selectedAccessory,
            ReplacementValue: replacementValue
        })).then(async (response) => {
            dispatch({
                type: MODAL_HIDE,
                modalProps: {
                    type: MODAL_TYPE_SUCCESS,
                    visible: false,
                }
            });
            if (response !== null && response !== "Failure") {
                await postToController(dispatch, 'GetCarDetails', JSON.stringify({
                    QuoteId: getState().sales.quoteId,
                    QuoteRiskItemId: getState().sales.carId,
                    RiskItemId: getState().sales.carId,
                })).then(async (carDetailsResponse) => {
                    if (carDetailsResponse.premiumError){
                        dispatch(showModalCalculatorBroke());
                    }
                    else {
                        await dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                carDetails: carDetailsResponse.carDetails.carDetails,
                                carPremium: carDetailsResponse.carDetails.carDetails.premium.toFixed(2).toString(),
                                quote: response.quote,
                                proRata: response.proRata,
                                totalPremium: carDetailsResponse.totalPremium
                            },
                        });
                    }
                });
            }
            else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error add accessories to quote, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
            dispatch({
                type: SET_QUOTE_DATA, payload: {
                    isInEdit: false,
                }
            });
            dispatch(navigateTo(DASHBOARD));
        }).finally(() => {

            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
            setTimeout(() => {
                dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
            }, 1000);
        })
    }
}

export const addCreditShortfall = (balloonPayment: any, loanDate: string) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        logEvent('SSP_add_credit_shortfall', getState().sales.quoteId + '/' + getState().sales.coverId);
        await postToController(dispatch, 'AddCreditShortfallToQuote', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            CoverId: getState().sales.coverId,
            RiskItemId: getState().sales.carId,
            LoanStartDate: loanDate,
            BalloonPercentage: balloonPayment
        })).then(async (response) => {
            await dispatch({
                type: MODAL_HIDE,
                modalProps: {
                    type: MODAL_TYPE_SUCCESS,
                    visible: false,
                }
            });
            if (response !== null && response !== "Failure") {
                await postToController(dispatch, 'GetCarDetails', JSON.stringify({
                    QuoteId: getState().sales.quoteId,
                    QuoteRiskItemId: getState().sales.carId,
                    RiskItemId: getState().sales.carId,
                })).then(async (carDetailsResponse) => {
                    if (carDetailsResponse.premiumError){
                        dispatch(showModalCalculatorBroke());
                    }
                    else {
                        await dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                carDetails: carDetailsResponse.carDetails.carDetails,
                                carPremium: carDetailsResponse.carDetails.carDetails.premium.toFixed(2).toString(),
                                quote: response.quote,
                                proRata: response.proRata,
                                totalPremium: carDetailsResponse.totalPremium
                            },
                        });
                    }
                });
            }
            else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error Add credit shortfall to quote, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
            dispatch({
                type: SET_QUOTE_DATA, payload: {
                    isInEdit: false,
                }
            });
            dispatch(navigateTo(DASHBOARD));
        }).finally(() => {

            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
            setTimeout(() => {
                dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
            }, 1000);
        })
    }
}

export const updateCreditShortfall = (balloonPayment: any, loanDate: string, selectedVap: any) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        logEvent('SSP_update_credit_shortfall', getState().sales.quoteId + '/' + getState().sales.coverId);
        await postToController(dispatch, 'UpdateCreditShortfallToQuote', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            CoverId: getState().sales.coverId,
            RiskItemId: getState().sales.carId,
            LoanStartDate: loanDate,
            BalloonPercentage: balloonPayment,
            SelectedVap: selectedVap
        })).then(async (response) => {
            await dispatch({
                type: MODAL_HIDE,
                modalProps: {
                    type: MODAL_TYPE_SUCCESS,
                    visible: false,
                }
            });
            if (response !== null && response !== "Failure") {
                await postToController(dispatch, 'GetCarDetails', JSON.stringify({
                    QuoteId: getState().sales.quoteId,
                    QuoteRiskItemId: getState().sales.carId,
                    RiskItemId: getState().sales.carId,
                })).then(async (carDetailsResponse) => {
                    if (carDetailsResponse.premiumError){
                        dispatch(showModalCalculatorBroke());
                    }
                    else {
                        await dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                carDetails: carDetailsResponse.carDetails.carDetails,
                                carPremium: carDetailsResponse.carDetails.carDetails.premium.toFixed(2).toString(),
                                quote: response.quote,
                                proRata: response.proRata,
                                totalPremium: carDetailsResponse.totalPremium
                            },
                        });
                    }
                });
            }
            else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error Add credit shortfall to quote, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
            dispatch({
                type: SET_QUOTE_DATA, payload: {
                    isInEdit: false,
                }
            });
            dispatch(navigateTo(DASHBOARD));
        }).finally(() => {

            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
            setTimeout(() => {
                dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
            }, 1000);
        })
    }
}

export const removeCreditShortfall = (balloonPayment: any, loanDate: string) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        logEvent('SSP_remove_credit_shortfall', getState().sales.quoteId + '/' + getState().sales.coverId);
        await postToController(dispatch, 'AddCreditShortfallToQuote', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            CoverId: getState().sales.coverId,
            RiskItemId: getState().sales.carId,
            LoanStartDate: loanDate,
            BalloonPercentage: balloonPayment.id
        })).then(async (response) => {
            await dispatch({
                type: MODAL_HIDE,
                modalProps: {
                    type: MODAL_TYPE_SUCCESS,
                    visible: false,
                }
            });
            if (response !== null && response !== "Failure") {
                await postToController(dispatch, 'GetCarDetails', JSON.stringify({
                    QuoteId: getState().sales.quoteId,
                    QuoteRiskItemId: getState().sales.carId,
                    RiskItemId: getState().sales.carId,
                })).then(async (carDetailsResponse) => {
                    if (carDetailsResponse.premiumError){
                        dispatch(showModalCalculatorBroke());
                    }
                    else {
                        await dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                carDetails: carDetailsResponse.carDetails.carDetails,
                                carPremium: carDetailsResponse.carDetails.carDetails.premium.toFixed(2).toString(),
                                quote: response.quote,
                                proRata: response.proRata,
                                totalPremium: carDetailsResponse.totalPremium
                            },
                        });
                    }
                });
            }
            else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error Add credit shortfall to quote, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
            dispatch({
                type: SET_QUOTE_DATA, payload: {
                    isInEdit: false,
                }
            });
            dispatch(navigateTo(DASHBOARD));
        }).finally(() => {

            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
            setTimeout(() => {
                dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
            }, 1000);
        })
    }
}

export const removeAccessoryFromQuote = (selectedAccessory: any) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        logEvent('SSP_remove_accessory_from_quote', getState().sales.quoteId + '/' + selectedAccessory);
        await postToController(dispatch, 'RemoveAccessoryFromQuote', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            CoverId: getState().sales.carId,
            SelectedAccessory: selectedAccessory
        })).then(async (response) => {
            await dispatch({
                type: MODAL_HIDE,
                modalProps: {
                    type: MODAL_TYPE_SUCCESS,
                    visible: false,
                }
            });
            if (response !== null && response !== "Failure") {
                await postToController(dispatch, 'GetCarDetails', JSON.stringify({
                    QuoteId: getState().sales.quoteId,
                    QuoteRiskItemId: getState().sales.carId,
                    RiskItemId: getState().sales.carId,
                })).then(async (carDetailsResponse) => {
                    if (carDetailsResponse.premiumError){
                        dispatch(showModalCalculatorBroke());
                    }
                    else {
                        await dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                carDetails: carDetailsResponse.carDetails.carDetails,
                                carPremium: carDetailsResponse.carDetails.carDetails.premium.toFixed(2).toString(),
                                quote: response.quote,
                                proRata: response.proRata,
                                totalPremium: carDetailsResponse.totalPremium
                            },
                        });
                    }
                })
            } else {
                logErrorToDatabase("Error removing accessory options in salesActions");
            }
        }).catch((err) => {
            logErrorToDatabase("Error removing accessory, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
            dispatch({
                type: SET_QUOTE_DATA, payload: {
                    isInEdit: false,
                }
            });
            dispatch(navigateTo(DASHBOARD));
        }).finally(() => {

            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
            setTimeout(() => {
                dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
            }, 1000);
        })
    }
}

export const acceptQuote = (isUpdate: boolean) => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'GetCartData', JSON.stringify({
            Parameter: getState().sales.quoteId,
        })).then(async (cartProducts) => {
            await postToController(dispatch, 'GetBankingDetails', JSON.stringify({
                PolicyId: getState().profile.policyId,
                QuoteId: getState().sales.quoteId
            })).then(async (response) => {
                if (cartProducts.premiumCalculationError){
                    dispatch(showModalCalculatorBroke());
                }
                else {
                    if (response) {
                        await dispatch({
                            type: SET_CUSTOMER_DATA, payload: {
                                bankingDetails: response,
                            }
                        })
                        await dispatch({
                            type: SET_CART_DATA, payload: {
                                products: cartProducts.products,
                                quote: getState().sales.quote,
                                quoteId: getState().sales.quoteId,
                                premiumCalculationError: cartProducts.premiumCalculationError
                            }
                        });
                        await dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                carPremium: cartProducts.premuim
                            }
                        });
                    }
                }
            })
        })
        if (!isUpdate) dispatch(navigateTo(BANKING_DETAILS))
    }
}

export const addBankingDetailsToQuote = () => {
    return async (dispatch, getState) => {
        dispatch({ type: LOADING_SCREEN_SHOW });
        logEvent('SSP_add_banking_details', getState().sales.quoteId);
        await postToController(dispatch, 'AddBankingDetailsToQuote', JSON.stringify({
            CustomerId: getState().sales.customerId,
            BankAccountTypeId: getState().sales.bankAccountTypeId,
            BankId: getState().sales.bankId,
            BranchId: getState().sales.branchId,
            AccountNumber: getState().sales.accountNumber,
            AccountHolder: getState().sales.name + ' ' + getState().sales.surname,
            AccountHolderIdNumber: getState().sales.idNumber,
            QuoteId: getState().sales.quoteId,
            AccountHolderIdTypeId: 1,
            IsPolicyHolder: getState().profile.activePolicies > 0,
            PolicyHolderConsent: true,
            IncomeSourceId: getState().sales.sourceOfIncomeId
        })).then(async (response) => {
            if (response === null || response === "Failure") {
                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        bankError: true,
                    },
                });
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: response,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error addBankingDetailsToQuote, Error: " + err);
            dispatch({
                type: SET_QUOTE_DATA, payload: {
                    bankError: true,
                },
            });
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
        dispatch({ type: LOADING_SCREEN_HIDE });
    }
}

export const addBankingDetailsNamToQuote = () => {
    return async (dispatch, getState) => {
        dispatch({ type: POLICY_LOAD_VIEW_SCREEN_SHOW });
        logEvent('SSP_add_banking_details', getState().sales.quoteId);
        await postToController(dispatch, 'AddBankingDetailsToQuote', JSON.stringify({
            CustomerId: getState().sales.customerId,
            BankAccountTypeId: getState().sales.bankAccountTypeId,
            BankId: getState().sales.bankId,
            BranchId: getState().sales.branchId,
            AccountNumber: getState().sales.accountNumber,
            AccountHolder: getState().sales.name + ' ' + getState().sales.surname,
            AccountHolderIdNumber: getState().sales.idNumber,
            QuoteId: getState().sales.quoteId,
            AccountHolderIdTypeId: 1,
            IsPolicyHolder: getState().profile.activePolicies > 0,
            PolicyHolderConsent: true,
            IncomeSourceId: getState().sales.sourceOfIncomeId
        })).then(async (response) => {
            if (response === null || response === "Failure") {
                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        bankError: true,
                    },
                });
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: response,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error addBankingDetailsToQuote, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
        dispatch({ type: POLICY_LOAD_VIEW_SCREEN_HIDE });
    }
}

export const addNewCompCar = () => {
    return async (dispatch) => {
        await dispatch({
            type: NEW_QUOTE_CAR
        });
        dispatch(navigateTo(CAR_REGISTRATION));
    };

}

export const editPolicyRiskItem = (item) => {
    return async (dispatch, getState) => {
        dispatch({ type: LOADING_SCREEN_SHOW })
        var request = JSON.stringify({
            PolicyId: getState().profile.policyId,
        });
        logEvent('SSP_edit_policy_risk_iten', getState().profile.policyId + "/" + getState().profile.selectedPersonalCover.id);
        await postToController(dispatch, 'CreateQuoteFromPolicy', request).then(async (response) => {
            if (response === null || response === "Failure" || response.success === false) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                dispatch(navigateTo(DASHBOARD));
            } else {
                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        quoteId: response.quoteId,
                        customerId: response.customerId,
                        quoteNumber: response.quoteNumber
                    }
                });
                await postToController(dispatch, 'GetCarDetailsForRiskItem', JSON.stringify({
                    QuoteId: response.quoteId,
                    QuoteRiskItemId: getState().profile.selectedPersonalCover.id,
                    RiskItemId: getState().profile.selectedPersonalCover.id,
                })).then(async (carDetailsResponse) => {
                    if (carDetailsResponse.premiumError){
                        dispatch(showModalCalculatorBroke());
                    }
                    else{
                        await postToController(dispatch, 'GetExcessSelection', JSON.stringify({
                            Excess: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                            ExcessId: carDetailsResponse.carDetails.carDetails.excessDetails.excessId,
                            ExcessOptions: carDetailsResponse.carDetails.carDetails.excessDetails.excessOptions
                        })).then(async (excessResponse) => {
                            await postToController(dispatch, 'GetVapOptions', JSON.stringify({
                                Parameter: getState().profile.countryId,
                            })).then(async (vapOptions) => {
                                await dispatch({
                                    type: SET_QUOTE_DATA, payload: {
                                        coverId: carDetailsResponse.carDetails.carDetails.quoteCoverId,
                                        carId: carDetailsResponse.riskItemId,
                                        carPremium: carDetailsResponse.carDetails.carDetails.premium.toFixed(2).toString(),
                                        excessList: excessResponse,
                                        selectedExcess: {
                                            description: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                                            id: carDetailsResponse.carDetails.carDetails.excessDetails.excessId
                                        },
                                        carDetails: carDetailsResponse.carDetails.carDetails,
                                        tyreAndRimOptions: vapOptions.tyreAndRim,
                                        littleDingsOptions: vapOptions.littleDingsAndTyreThings,
                                        carHireOptions: vapOptions.carHire,
                                        balloonOptions: vapOptions.baloonPercentage,
                                        isNewItem: true,
                                        isInEdit: true,
                                        totalPremium: carDetailsResponse.totalPremium
                                    },
                                });
                            }).catch(err => {
                                dispatch({
                                    type: MODAL_SHOW,
                                    modalProps: {
                                        type: MODAL_TYPE_ERROR,
                                        header: ERROR_HEADER,
                                        body: ERROR_SOMETHING_WENT_WRONG,
                                    }
                                });
                                logErrorToDatabase("Error GetVapOptions in salesActions: " + err);
                            })
                        }).catch(err => {
                            dispatch({
                                type: MODAL_SHOW,
                                modalProps: {
                                    type: MODAL_TYPE_ERROR,
                                    header: ERROR_HEADER,
                                    body: ERROR_SOMETHING_WENT_WRONG,
                                }
                            });
                            logErrorToDatabase("Error GetExcessSelection in salesActions: " + err);
                        })
                    }
                }).catch(err => {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    });
                    logErrorToDatabase("Error GetCarDetails in salesActions: " + err);
                })
            }
        }).catch(err => {
            logErrorToDatabase("Unable to create policy, Error: " + err)
        }).finally(() => {
            dispatch({ type: LOADING_SCREEN_HIDE });
        })
    }
}

export const editPortablePolicyRiskItem = (item) => {
    return async (dispatch, getState) => {
        dispatch({ type: LOADING_SCREEN_SHOW })
        var request = JSON.stringify({
            PolicyId: getState().profile.policyId,
        });
        await postToController(dispatch, 'CreateQuoteFromPolicy', request).then(async (response) => {
            if (response === null || response === "Failure" || response.success === false) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                dispatch(navigateTo(DASHBOARD));
            } else {
                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        quoteId: response.quoteId,
                        customerId: response.customerId,
                        quoteNumber: response.quoteNumber
                    }
                });
            }
        }).catch(err => {
            logErrorToDatabase("Unable to create policy, Error: " + err)
        }).finally(() => {
            dispatch({ type: LOADING_SCREEN_HIDE });
        })
    }
}

export const editBlingPolicyRiskItem = (item) => {
    return async (dispatch, getState) => {
        dispatch({ type: UPDATE_POLICY_LOADER_SCREEN_SHOW })
        var request = JSON.stringify({
            PolicyId: getState().profile.policyId,
        });
        await postToController(dispatch, 'CreateQuoteFromPolicy', request).then(async (response) => {
            if (response === null || response === "Failure" || response.success === false) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                dispatch(navigateTo(DASHBOARD));
            } else {
                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        quoteId: response.quoteId,
                        customerId: response.customerId,
                        quoteNumber: response.quoteNumber
                    }
                });
            }
        }).catch(err => {
            logErrorToDatabase("Unable to create policy, Error: " + err)
        }).finally(() => {
            dispatch({ type: UPDATE_POLICY_LOADER_SCREEN_HIDE });
        })
    }
}

export const addReplacementValue = () => {
    return async (dispatch) => {
        await dispatch({
            type: NEW_QUOTE_CAR
        });
        dispatch(navigateTo(ADD_REPLACEMENT_VALUE));
    };
}

export const setPortablePossessionType = (id: any, itemType: any) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                portablePossessionTypeId: id,
                portablePossessionType: itemType,
            }
        });
    }
}

export const setReplacementValue = (value: number) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                replacementValue: value,
            }
        });
    }
}

export const setStartReplacementValue = (value: string) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                startReplacementValue: value,
            }
        });
    }
}

export const getPortableRiskItemDetailedInfo = (policyRiskItemId: string, riskItemType: number) => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'V1/GetRiskItemDetailedInfo', JSON.stringify({
            policyRiskItemId: policyRiskItemId,
            riskItemType: 1
        })).then(async (response) => {
            if (response) {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        portablePossessionTypeId: response.policyAllRisk.specifiedItemCategory.id,
                        portablePossessionType: response.policyAllRisk.specifiedItemCategory.description,
                        lastClaim: response.policyAllRisk.lastClaim,
                        portablePossessionRisk: { 'id': response.policyAllRisk.numberClaims },
                        portablePossessionDescription: response.policyAllRisk.description,
                        portablePossessionMakeId: response.policyAllRisk.makeId,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error GetRiskItemDetailedInfo, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
    }
}

export const getBlingRiskItemDetailedInfo = (policyRiskItemId: string, riskItemType: number) => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'V1/GetRiskItemDetailedInfo', JSON.stringify({
            policyRiskItemId: policyRiskItemId,
            riskItemType: 1

        })).then(async (response) => {
            if (response) {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        blingTypeId: response.policyAllRisk.specifiedItemCategory.id,
                        blingMakeId: response.policyAllRisk.specifiedItemMakeId,
                        blingType: response.policyAllRisk.specifiedItemCategory.description,
                        lastClaim: response.policyAllRisk.lastClaim,
                        blingRisk: { 'id': response.policyAllRisk.numberClaims },
                        blingDescription: response.policyAllRisk.description,
                        cellPhoneMemoryTypeId: response.policyAllRisk.cellPhoneMemoryTypeId,
                        cellPhoneModelId: response.policyAllRisk.cellPhoneModelId,
                        cellPhoneMakeId: response.policyAllRisk.specifiedItemMakeId,
                        serialNumber: response.policyAllRisk.serialNumber,
                        cellPhoneInitials: response.policyAllRisk.initials,
                        cellPhoneSurname: response.policyAllRisk.surname,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error GetRiskItemDetailedInfo, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
    }
}

export const setPortableItemDetails = (policyRiskItemId: string) => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'GetMobileQuote', JSON.stringify({
            Parameter: getState().sales.quoteId
        })).then(async (response) => {
            if (response.premiumError){
                dispatch(showModalCalculatorBroke());
            }
            else {
                var data = response.quoteItems.filter(x => x.quoteRiskItem.policyRiskItemId === policyRiskItemId)[0];
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        portableItemDetails: {'riskItemId': data.quoteRiskItem.id},
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error GetMobileQuote, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
    }
}

export const setBlingItemDetails = (policyRiskItemId: string) => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'GetMobileQuote', JSON.stringify({
            Parameter: getState().sales.quoteId
        })).then(async (response) => {
            if (response.premiumError){
                dispatch(showModalCalculatorBroke());
            }
            else {
                var data = response.quoteItems.filter(x => x.quoteRiskItem.policyRiskItemId === policyRiskItemId)[0];
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        blingItemDetails: {'riskItemId': data.quoteRiskItem.id},
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error GetMobileQuote, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
    }
}

export const checkReplacementValue = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'ValidatePortablePossessionValues', JSON.stringify({
            items:
                [{ possessionType: getState().sales.portablePossessionTypeId, replacementValue: parseFloat(getState().sales.replacementValue) }]
        })).then(async (response) => {
            if (response.items) {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        replacementCheckResult: response.items[0].checkResult,
                        MinReplacementValue: response.items[0].minimumValue,
                        MaxReplacementValue: response.items[0].maximumValue,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error ValidatePortablePossessionValues, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
    }
}

export const checkBlingReplacementValue = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'ValidatePortablePossessionValues', JSON.stringify({
            items:
                [{ possessionType: getState().sales.blingTypeId, replacementValue: parseFloat(getState().sales.replacementValue) }]
        })).then(async (response) => {
            if (response.items) {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        replacementCheckResult: response.items[0].checkResult,
                        MinReplacementValue: response.items[0].minimumValue,
                        MaxReplacementValue: response.items[0].maximumValue,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error ValidatePortablePossessionValues, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
    }
}

export const setPortablePossessionsRisk = (PortablePossessionRisk: any) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                portablePossessionRisk: PortablePossessionRisk,
            }
        });
        dispatch(navigateTo(PORTABLE_POSSESSIONS_CLAIM_HISTORY));
    }
}

export const setPortablePossessionsLastClaim = (PortablePossessionsLastClaim: any) => {
    return async (dispatch) => {
        await dispatch({
            type: SET_QUOTE_DATA, payload: {
                portablePossessionlastClaim: PortablePossessionsLastClaim,
                isNewItem: true
            }
        });
    }
}

export const setportablePossessionDescription = (portablePossessionDescription: any) => {
    return async (dispatch) => {
        await dispatch({
            type: SET_QUOTE_DATA, payload: {
                portablePossessionDescription: portablePossessionDescription,
            }
        });
    }
}

export const addPortablePossessionsToQuote = (isCellphone = false) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        var success = true;
        logEvent('SSP_add_portable_to_quote', getState().sales.quoteId);
        await postToController(dispatch, 'AddSingleAllRiskToQuote', JSON.stringify(
            {
                quoteId: getState().sales.quoteId,
                quoteRiskItemId: "00000000-0000-0000-0000-000000000000",
                specifiedItemCategoryId: getState().sales.portablePossessionTypeId,
                selectedCoverTypeId: isCellphone ? BLING_BRAND_NEW_COVER_TYPE : PORTABLE_COVER_TYPE,
                replacementValue: getState().sales.replacementValue,
                description: getState().sales.portablePossessionDescription,
                numberClaims: getState().sales.portablePossessionRisk.id,
                numberCellPhoneClaims: getState().sales.portablePossessionRisk.id,
                lastClaimId: Number(getState().sales.portablePossessionlastClaim.id),
                ratingsEffectiveDate: null,
                specifiedItemMakeId: getState().sales.portablePossessionMakeId != "" ? getState().sales.portablePossessionMakeId : null,
                initials: Number(getState().sales.regularDriverRelationship?.id) == 0 ? getState().profile.policyId !== "" ? getState().sales.name : getState().sales.name : getState().sales.regularDriverOtherName,
                dateOfBirth: null,
                cellphoneNumber: isCellphone ? getState().sales.riskItemPhonenumber : null,
                relationshipTypeId: Number(getState().sales.regularDriverRelationship?.id) == 0 ? 1 : Number(getState().sales.regularDriverRelationship?.id),
                source: 3,
                serialNumber: "",
                underwritingType: 2,
                intermediaryId: null,
                productExcessId: null,
                hasProtectiveCase: getState().sales.protectiveCase,
                cellModelId: getState().sales.portablePossessionModelId != "" ? getState().sales.portablePossessionModelId : null,
                makeId: getState().sales.portablePossessionMakeId != "" ? getState().sales.portablePossessionMakeId : null,
                cellMemoryId: getState().sales.portablePossessionMemoryTypeId != "" ? getState().sales.portablePossessionMemoryTypeId : null,
                surname: Number(getState().sales.regularDriverRelationship?.id) == 0 ? getState().profile.policyId !== "" ? getState().sales.surname : getState().sales.surname : getState().sales.regularDriverOtherSurname,
                idNumber: Number(getState().sales.regularDriverRelationship?.id) == 0 ? getState().sales.idNumber : getState().sales.regularDriverOtherIdNumber,
            }

        )).then(async (response) => {
            if (response !== "Failure" && response !== "") {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        portableItemDetails: response,
                        startReplacementValue: getState().sales.replacementValue,
                        proRata: response.proRataPremium.toFixed(2),
                    }
                });
            } else {
                success = false;
                logErrorToDatabase("Error adding portable possession non cellphone to quote in salesActions");
            }
        }).catch((err) => {
            logErrorToDatabase("Error portable possession non cellphone, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            if (success) {
                dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_HIDE });
                    dispatch(navigateTo(QUOTATION))
                }, 1000);
            } else {
                if (getState().sales.quoteType === PRODUCT_BLING) {
                    dispatch(navigateTo(GET_BLING_INSURANCE))
                } else {
                    dispatch(navigateTo(GET_PORTABLE_POSSESSIONS_INSURANCE));
                }
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        })
    }
}

export const addBlingToQuote = () => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        var success = true;
        logEvent('SSP_add_cellphone_to_quote', getState().sales.quoteId);
        await postToController(dispatch, 'AddSingleAllRiskToQuote', JSON.stringify(
            {
                quoteId: getState().sales.quoteId,
                quoteRiskItemId: "00000000-0000-0000-0000-000000000000",
                specifiedItemCategoryId: 2,
                selectedCoverTypeId: "4c0cb071-42dd-4060-99ff-9f0214113458",
                replacementValue: getState().sales.replacementValue,
                description: getState().sales.blingDescription,
                numberClaims: getState().sales.blingRisk.id,
                numberCellPhoneClaims: getState().sales.blingRisk.id,
                lastClaimId: Number(getState().sales.lastClaim.id),
                ratingsEffectiveDate: null,
                specifiedItemMakeId: getState().sales.cellPhoneMakeId,
                cellModelId: getState().sales.cellPhoneModelId,
                cellMemoryId: getState().sales.blingTypeId,
                makeId: getState().sales.cellPhoneMakeId,
                initials: null,
                surname: getState().sales.surname,
                dateOfBirth: null,
                cellphoneNumber: getState().sales.riskItemPhonenumber,
                relationshipTypeId: null,
                source: 3,
                serialNumber: null,
                underwritingType: 2,
                intermediaryId: null,
                productExcessId: null
            }

        )).then(async (response) => {
            if (response !== "Failure" && response !== "") {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        portableItemDetails: response,
                        startReplacementValue: getState().sales.replacementValue,
                        proRata: response.proRataPremium.toFixed(2),
                    }
                });
            } else {
                success = false;
                logErrorToDatabase("Error adding portable possession cellphone to quote in salesActions");
            }
        }).catch((err) => {
            logErrorToDatabase("Error portable possession cellphone, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            if (success) {
                dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_HIDE });
                    if (getState().sales.quoteType === PRODUCT_BLING) {
                        dispatch(navigateTo(COVER_OPTIONS))
                    }
                }, 1000);
            } else {
                if (getState().sales.quoteType === PRODUCT_BLING) {
                    dispatch(navigateTo(COVER_OPTIONS))
                } else {
                    dispatch(navigateTo(GET_BLING_INSURANCE));
                }
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        })
    }
}

export const getBlingQuotes = () => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        var success = true;
        await postToController(dispatch, 'GetBlingQuotes', JSON.stringify(
            {
                quoteId: getState().sales.quoteId,
                replacementValue: getState().sales.replacementValue,
                description: getState().sales.portablePossessionDescription,
                numberClaims: getState().sales.portablePossessionRisk.id,
                lastClaimId: Number(getState().sales.portablePossessionlastClaim.id),
                specifiedItemMakeId: getState().sales.portablePossessionMakeId,
                cellModelId: getState().sales.portablePossessionModelId,
                makeId: getState().sales.portablePossessionMakeId,
                cellphoneNumber: getState().sales.riskItemPhonenumber,
                relationshipTypeId: Number(getState().sales.regularDriverRelationship.id) == 0 ? 1 : Number(getState().sales.regularDriverRelationship.id),
                serialNumber: "",
                underwritingType: 2,
                initials: Number(getState().sales.regularDriverRelationship.id) == 0 ? getState().profile.policyId !== "" ? getState().sales.name : getState().sales.regularDriverOtherName : getState().sales.name,
                Surname: Number(getState().sales.regularDriverRelationship.id) == 0 ? getState().profile.policyId !== "" ? getState().sales.surname : getState().sales.regularDriverOtherSurname : getState().sales.surname,
                IdNumber: Number(getState().sales.regularDriverRelationship.id) == 0 ? getState().profile.policyId !== "" ? getState().sales.idNumber : getState().sales.regularDriverOtherIdNumber : getState().sales.idNumber,
            }
        )).then(async (response) => {
            if (response !== "Failure" && response !== "") {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        blingPremiums: response,
                    }
                });
            } else {
                success = false;
                logErrorToDatabase("Error adding portable possession for bling quotes to quote in salesActions");
            }
        }).catch((err) => {
            logErrorToDatabase("Error portable possession for bling quotes, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            if (success) {
                dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_HIDE });
                    if (getState().sales.quoteType === PRODUCT_BLING) {
                        dispatch(navigateTo(COVER_OPTIONS))
                    }
                }, 1000);
            } else {
                if (getState().sales.quoteType === PRODUCT_BLING) {
                    dispatch(navigateTo(COVER_OPTIONS))
                } else {
                    dispatch(navigateTo(GET_PORTABLE_POSSESSIONS_INSURANCE));
                }
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        })
    }
}

export const updatePortablePossessionsToQuote = () => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        var success = true;
        var lastClaimToUse = 0;
        if (Number(getState().sales.lastClaim.id)) {
            lastClaimToUse = Number(getState().sales.lastClaim.id)
        }
        logEvent('SSP_update_portable_to_quote', getState().sales.quoteId);
        await postToController(dispatch, 'UpdateSingleRiskItemOnQuote', JSON.stringify(
            {
                quoteId: getState().sales.quoteId,
                quoteRiskItemId: getState().sales.portableItemDetails?.riskItemId,
                specifiedItemCategoryId: getState().sales.portablePossessionTypeId ? getState().sales.portablePossessionTypeId : 1,
                selectedCoverTypeId: PORTABLE_COVER_TYPE,
                replacementValue: getState().sales.replacementValue,
                description: getState().sales.portablePossessionDescription,
                numberClaims: getState().sales.portablePossessionRisk.id,
                numberCellPhoneClaims: null,
                lastClaimId: lastClaimToUse,
                ratingsEffectiveDate: null,
                specifiedItemMakeId: null,
                cellModelId: null,
                cellMemoryId: null,
                initials: getState().sales.name ? getState().sales.name.substring(0, 1) : "",
                surname: getState().sales.surname,
                dateOfBirth: null,
                cellphoneNumber: null,
                relationshipTypeId: null,
                source: 3,
                serialNumber: null,
                underwritingType: 2,
                intermediaryId: null,
                productExcessId: null
            }

        )).then(async (response) => {
            if (response !== "Failure" && response !== "") {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        portableItemDetails: response,
                        startReplacementValue: getState().sales.replacementValue,
                        proRata: response.proRataPremium.toFixed(2),
                    }
                });
            } else {
                success = false;
                logErrorToDatabase("Error updating portable possession on quote in salesActions");
            }
        }).catch((err) => {
            logErrorToDatabase("Error portable possession update, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            if (success) {
                dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_HIDE });
                }, 1000);
            } else {
                dispatch(navigateTo(GET_PORTABLE_POSSESSIONS_INSURANCE));
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        })
    }
}

export const updateBlingReplacementValueToQuote = () => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        var success = true;
        logEvent('SSP_update_cellphone_replacement_value', getState().sales.quoteId);
        await postToController(dispatch, 'UpdateSingleRiskItemOnQuote', JSON.stringify(
            {
                quoteId: getState().sales.quoteId,
                quoteRiskItemId: getState().sales.portableItemDetails.quoteRiskItem.id,
                specifiedItemCategoryId: 2,
                selectedCoverTypeId: getState().sales.portableItemDetails.quoteCovers[0].id,
                replacementValue: getState().sales.replacementValue,
                description: getState().sales.portablePossessionDescription,
                numberClaims: getState().sales.portablePossessionRisk.id,
                numberCellPhoneClaims: getState().sales.portablePossessionRisk.id,
                lastClaimId: Number(getState().sales.portablePossessionlastClaim.id),
                ratingsEffectiveDate: null,
                specifiedItemMakeId: getState().sales.portablePossessionMakeId,
                cellModelId: getState().sales.portablePossessionModelId,
                cellMemoryId: getState().sales.portablePossessionMemoryTypeId,
                makeId: getState().sales.portablePossessionMakeId,
                initials: getState().sales.name ? getState().sales.name.substring(0, 1) : "",
                surname: getState().sales.surname,
                dateOfBirth: null,
                cellphoneNumber: getState().sales.riskItemPhonenumber,
                relationshipTypeId: Number(getState().sales.regularDriverRelationship.id) == 0 ? 1 : Number(getState().sales.regularDriverRelationship.id),
                source: 3,
                serialNumber: null,
                underwritingType: 2,
                intermediaryId: null,
                productExcessId: null
            }
        )).then(async (response) => {
            if (response !== "Failure" && response !== "") {
                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        portableItemDetails: response
                    }
                });
            } else {
                success = false;
                logErrorToDatabase("Error updating portable possession on quote in salesActions");
            }
        }).catch((err) => {
            logErrorToDatabase("Error portable possession update, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            if (success) {
                dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
                }, 1000);
            } else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        })
    }
}

export const updatePortableRiskItemToQuote = () => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        var success = true;
        logEvent('SSP_update_portable_value', getState().sales.quoteId);
        await postToController(dispatch, 'UpdateSingleRiskItemOnQuote', JSON.stringify(
            {
                quoteId: getState().sales.quoteId,
                quoteRiskItemId: getState().sales.portableItemDetails?.riskItemId,
                specifiedItemCategoryId: getState().sales.portablePossessionTypeId ? getState().sales.portablePossessionTypeId : 1,
                selectedCoverTypeId: PORTABLE_COVER_TYPE,
                replacementValue: getState().sales.replacementValue,
                description: getState().sales.portablePossessionDescription,
                numberClaims: getState().sales.portablePossessionRisk.id,
                numberCellPhoneClaims: null,
                lastClaimId: getState().sales.lastClaim.id,
                ratingsEffectiveDate: null,
                specifiedItemMakeId: getState().sales.portablePossessionMakeId,
                cellModelId: null,
                cellMemoryId: null,
                initials: null,
                surname: null,
                dateOfBirth: null,
                cellphoneNumber: null,
                relationshipTypeId: null,
                source: 3,
                serialNumber: null,
                underwritingType: 2,
                intermediaryId: null,
                productExcessId: null
            }

        )).then(async (response) => {
            if (response !== "Failure" && response !== "") {
                var portableDetail = getState().sales.selectedPortableDetail;
                var total = (parseFloat(getState().profile.selectedPersonalPolicy.totalPolicyPremium) - portableDetail.premium) + response.premium;
                portableDetail.premium = response.premium;

                portableDetail.totalPolicyPremium = total.toFixed(2);

                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        portableItemDetails: response,
                        startReplacementValue: getState().sales.replacementValue,
                        totalPremium: total.toFixed(2),
                        totalPolicyPremium: total.toFixed(2),
                        proRata: response.proRataPremium.toFixed(2),
                        carPremium: response.premium,
                        selectedPortableDetail: portableDetail
                    }
                });
            } else {
                success = false;
                logErrorToDatabase("Error updating portable possession on quote in salesActions");
            }
        }).catch((err) => {
            logErrorToDatabase("Error portable possession update, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            if (success) {
                dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
                }, 1000);
            } else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        })
    }
}

export const updateBlingRiskItemToQuote = (selectedCoverTypeId: string) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        var success = true;
        logEvent('SSP_update_cellphone_value', getState().sales.quoteId);
        await postToController(dispatch, 'UpdateSingleRiskItemOnQuote', JSON.stringify(
            {
                quoteId: getState().sales.quoteId,
                quoteRiskItemId: getState().sales.blingItemDetails?.riskItemId,
                specifiedItemCategoryId: getState().sales.blingTypeId ? getState().sales.blingTypeId : 1,
                selectedCoverTypeId: selectedCoverTypeId,
                replacementValue: getState().sales.replacementValue,
                description: getState().sales.blingDescription,
                numberClaims: getState().sales.blingRisk.id,
                numberCellPhoneClaims: null,
                lastClaimId: getState().sales.lastClaim.id,
                ratingsEffectiveDate: null,
                specifiedItemMakeId: getState().sales.blingMakeId,
                cellModelId: getState().sales.cellPhoneModelId,
                cellMemoryId: getState().sales.cellPhoneMemoryTypeId,
                makeId: getState().sales.cellPhoneMakeId,
                initials: getState().sales.cellPhoneInitials,
                surname: getState().sales.cellPhoneSurname,
                dateOfBirth: null,
                cellphoneNumber: getState().sales.selectedBlingDetail.cellPhoneNumber,
                relationshipTypeId: null,
                source: 3,
                serialNumber: getState().sales.serialNumber,
                underwritingType: 2,
                intermediaryId: null,
                productExcessId: null
            }
        )).then(async (response) => {
            if (response !== "Failure" && response !== "") {
                var blingDetail = getState().sales.selectedBlingDetail;

                var total = (parseFloat(getState().profile.selectedPersonalPolicy.totalPolicyPremium) - blingDetail.premium) + response.premium;

                blingDetail.premium = response.premium;

                blingDetail.totalPolicyPremium = total.toFixed(2);

                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        portableItemDetails: response,
                        startReplacementValue: getState().sales.replacementValue,
                        totalPremium: total.toFixed(2),
                        totalPolicyPremium: total.toFixed(2),
                        proRata: response.proRataPremium.toFixed(2),
                        carPremium: response.premium,
                        selectedBlingDetail: blingDetail
                    }
                });
            } else {
                success = false;
                logErrorToDatabase("Error updating portable possession on quote in salesActions");
            }
        }).catch((err) => {
            logErrorToDatabase("Error portable possession update, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            if (success) {
                dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: UPDATE_POLICY_LOADER_SUCCESS_SCREEN_HIDE });
                }, 1000);
            } else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        })
    }
}

export const setRegularPhoneNumber = (regularPhoneNumber: string) => {
    return (dispatch, getState) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                riskItemPhonenumber: regularPhoneNumber
            }
        });
    }
}

export const setCellphoneDetails = (MakeId: number, ModelId: number, MemoryTypeId: number, Description: string) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                portablePossessionMakeId: MakeId,
                portablePossessionModelId: ModelId,
                portablePossessionMemoryTypeId: MemoryTypeId,
                portablePossessionDescription: Description,
            }
        });
    }
}

export const getLegalQuestions = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'GetLegalQuestions', JSON.stringify({
            Parameter: getState().profile.countryId

        })).then(async (response) => {
            if (response) {
                let responseSet: AdminJudgementQuestion[] = response.adminJudgementQuestions as AdminJudgementQuestion[];
                let secondaryAdminJudgementAnswerSet: secondaryAdminJudgementAnswer[] = [];
                let adminJudgementAnswerSet: adminJudgementAnswer[] = responseSet.map((item) => {
                    let itemToAdd: adminJudgementAnswer = {
                        Answer: undefined,
                        QuestionId: item.id
                    }
                    item.secondaryAdminJudgementQuestions.forEach((function (secondaryQuestion) {
                        let secondaryItemToAdd: secondaryAdminJudgementAnswer = {
                            adminJudgementQuestionId: item.id,
                            secondaryQuestionId: secondaryQuestion.id,
                            questionType: secondaryQuestion.secondaryQuestionType,
                            dateAnswerStr: undefined
                        }
                        secondaryAdminJudgementAnswerSet.push(secondaryItemToAdd);
                    }));
                    return itemToAdd;
                });

                let answerSet: AdminJudgementAnswerSet = { adminJudgementAnswers: adminJudgementAnswerSet, secondaryAdminJudgementAnswers: secondaryAdminJudgementAnswerSet };
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        adminJudgementQuestions: response.adminJudgementQuestions as AdminJudgementQuestion[],
                        adminJudgementAnswerSet: answerSet
                    }
                });
            }

        }).catch((err) => {
            logErrorToDatabase("Error GetLegalQuestions, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
        dispatch(setLegalQuestionValidation(true));
    }
}

export const setAdminJudgementAnswers = (answers: any) => {
    return async (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                adminJudgementAnswerSet: answers,
            }
        });
        return true;
    }
}

export const setLegalAnswerById = (questionId: string, answerDate: string, answerBool: boolean = false, answerId: number) => {
    return async (dispatch, getState) => {
        let answerSet = getState().sales.adminJudgementAnswerSet as AdminJudgementAnswerSet;
        let adminAnswerSet = answerSet.adminJudgementAnswers;
        adminAnswerSet = adminAnswerSet.map((item) => {
            if (item.QuestionId === questionId) {
                item.Answer = answerBool;
            }
            return item;
        });

        let secondaryAdminAnswerSet = answerSet.secondaryAdminJudgementAnswers;
        secondaryAdminAnswerSet = secondaryAdminAnswerSet.map((item) => {
            if (item.secondaryQuestionId === questionId) {

                item.questionType === 2 ? (item.dateAnswerStr = answerDate) : (item.dropdownAnswer = answerId);
            }
            return item;
        });

        answerSet.adminJudgementAnswers = adminAnswerSet;
        answerSet.secondaryAdminJudgementAnswers = secondaryAdminAnswerSet;

        dispatch({
            type: SET_QUOTE_DATA, payload: {
                adminJudgementAnswerSet: answerSet,
            }
        });
    }
}

export const setSelectedPortableDetail = (item: object) => {
    return (dispatch, getState) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                selectedPortableDetail: item
            }
        });
    }
}

export const setSelectedBlingDetail = (item: object) => {
    return (dispatch, getState) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                selectedBlingDetail: item
            }
        });
    }
}

export const submitLegalQuestions = () => {
    return async (dispatch, getState) => {
        dispatch({ type: POLICY_LOAD_VIEW_SCREEN_SHOW })
        logEvent('SSP_submit_legal_questions', getState().sales.quoteId);
        await postToController(dispatch, 'SubmitLegalQuestions', JSON.stringify(
            {
                quoteId: getState().sales.quoteId,
                adminJudgementAnswers: getState().sales.adminJudgementAnswerSet.adminJudgementAnswers as adminJudgementAnswer[],
                secondaryAdminJudgementAnswers: getState().sales.adminJudgementAnswerSet.secondaryAdminJudgementAnswers as secondaryAdminJudgementAnswer[],
            }
        )).then(async (response) => {
            if (response !== "Failure" && response !== "") {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        referralResponse: response,
                    }
                });
                if (response.autoDecline) {
                    await dispatch(discardCartPortable());
                    dispatch(showHardRejectedModal());
                    dispatch({ type: POLICY_LOAD_VIEW_SCREEN_HIDE });
                }
                else if (response.requiresApproval) {
                    dispatch(showSoftRejectedModal());
                    dispatch({ type: POLICY_LOAD_VIEW_SCREEN_HIDE });
                } else {
                    if (getState().profile.policyId === "") {
                        await dispatch(createPolicy());
                    }
                    else {
                        await dispatch(updatePolicy());
                        await dispatch(discardCart());
                    }
                }
            } else {
                logErrorToDatabase("Error submitting legal questions on quote in salesActions");
            }
        }).catch((err) => {
            logErrorToDatabase("Error legal questions submit, Error: " + err);
        });
    }
}

export const checkLegalQuestionValidation = () => {
    return async (dispatch, getState) => {
        var isIncomplete = false;
        var adminjudgementQuestions = getState().sales.adminJudgementQuestions as AdminJudgementQuestion[];
        var adminjudgementAnswersSet = getState().sales.adminJudgementAnswerSet as AdminJudgementAnswerSet;
        let secondaryQuestionSet = adminjudgementAnswersSet.secondaryAdminJudgementAnswers;
        var adminjudgementAnswers = adminjudgementAnswersSet.adminJudgementAnswers;

        adminjudgementAnswers.forEach((function (answer) {
            if (answer.Answer === undefined) {
                isIncomplete = true;
            }
            else if (answer.Answer) {
                let secondaryQuestionList = adminjudgementQuestions.find(x => x.id === answer.QuestionId)?.secondaryAdminJudgementQuestions;
                secondaryQuestionList?.forEach((function (secondaryItem) {
                    let secondaryQuestionAnswer = secondaryQuestionSet.find(x => x.secondaryQuestionId === secondaryItem.id)
                    if (secondaryQuestionAnswer?.questionType === 1 && !secondaryQuestionAnswer?.dropdownAnswer) {
                        isIncomplete = true;
                    }
                    if (secondaryQuestionAnswer?.questionType === 2 && !secondaryQuestionAnswer?.dateAnswerStr === undefined) {
                        isIncomplete = true;
                    }
                }));
            }
        }));
        dispatch(setLegalQuestionValidation(isIncomplete));
        return isIncomplete;
    }
}

export const setLegalQuestionValidation = (item: boolean) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                validationErrorLegalQuestions: item
            }
        });
    }
}

export const resetSecondaryLegalQuestionByPrimaryId = (questionGuid: string) => {
    return async (dispatch, getState) => {
        let adminJudgementAnswerSetUpdate = getState().sales.adminJudgementAnswerSet as AdminJudgementAnswerSet
        let modifiedAnswerSet = adminJudgementAnswerSetUpdate.secondaryAdminJudgementAnswers.map((item) => {
            if (item.adminJudgementQuestionId === questionGuid) {
                item.dropdownAnswer = undefined;
                item.dateAnswerStr = undefined;
            }
            return item;
        });
        adminJudgementAnswerSetUpdate.secondaryAdminJudgementAnswers = modifiedAnswerSet;
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                adminJudgementAnswerSet: adminJudgementAnswerSetUpdate
            }
        });
    }
}

export const setIsOnQuoteScreen = (item: boolean, riskItemId: any, description: any) => {
    return (dispatch) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                isQuoteScreen: item,
                quoteScreenRiskId: riskItemId,
                quoteScreenRiskDescription: description
            }
        });
    }
}

export const addAcceptedBlingQuote = (item) => {
    return (dispatch, getState) => {
        var acceptedArray = getState().sales.acceptedBlingCovers;
        if (acceptedArray == undefined) {
            acceptedArray = []
        }
        acceptedArray.push(item)
        var acceptedNumbers = getState().sales.addedBlingNumbers;
        var numberToAdd = {
            number: getState().sales.riskItemPhonenumber,
            coverId: item
        }
        if (acceptedNumbers == undefined) {
            acceptedNumbers = []
        }
        acceptedNumbers.push(numberToAdd)
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                acceptedBlingCovers: acceptedArray,
                addedBlingNumbers: acceptedNumbers,
            }
        });
    }
}

export const removeAcceptedBlingQuote = (item) => {
    return (dispatch, getState) => {
        var acceptedNumbers = getState().sales.addedBlingNumbers;
        if (acceptedNumbers == undefined) {
            acceptedNumbers = []
        }
        var numberToRemove = getState().cart.products.find(x => x.riskItemId == item).cellphoneNumber;
        acceptedNumbers = acceptedNumbers.filter(x => x != numberToRemove);
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                addedBlingNumbers: acceptedNumbers,
            }
        });
    }
}

export const acceptBlingCover = (item) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        var acceptCovers = getState().sales.acceptedBlingCovers;
        if (acceptCovers == undefined) {
            acceptCovers = [];
        }
        var blingCover = undefined;
        if (item) {
            acceptCovers.push(item);
            blingCover = getState().sales.blingPremiums.blingQuotes.find(x => x.riskItemId == item);
        }
        await postToController(dispatch, 'AcceptBlingQuote', JSON.stringify(
            {
                quoteId: getState().sales.quoteId,
                AcceptedItems: acceptCovers,
                RemovedRiskItemIds: null,
            }
        )).then(async (response) => {
            if (response !== "Failure" && response !== "") {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        acceptBlingQuote: response
                    }
                });
                if (item) {
                    dispatch(navigateTo(QUOTATION))
                }
            } else {
                logErrorToDatabase("Error accepting bling cover in salesActions");
            }
        }).catch((err) => {
            logErrorToDatabase("Error accept bling quote submit, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
        })
    }
}

export const getIsIMEINumberActive = (IMEINumber: string) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                iMEINumber: IMEINumber,
            }
        });
        var coverToUse;
        let IdToUse = getState().profile.selectedPersonalCover.riskItems[0].id;
        let IdToSend = getState().profile.selectedPersonalCover.riskItems[0].id;
        if (getState().profile.selectedPersonalCover.product === 6) {
            IdToSend = getState().profile.selectedPortablePossession.id;
        }

        await postToController(dispatch, "IsImeiNumberOnActiveRiskItem", JSON.stringify({
            parameter: IMEINumber
        })).then(async (response) => {
            if (response !== "Failure" && response !== "" && response !== true) {
                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        isIMEINumberActive: response
                    }
                });
                await postToController(dispatch, "BlingUpdateIMEI", JSON.stringify({
                    PolicyId: getState().profile.policyId,
                    QuoteAllRiskId: IdToSend,
                    SerialNumber: IMEINumber
                })).then(async (responseUpdate) => {
                    if (responseUpdate) {
                        await postToController(dispatch, 'GetPolicyDataByCustomerId', JSON.stringify({
                            Parameter: getState().profile.customerId
                        })).then(async (responseGetPolicy) => {
                            try {
                                if (responseGetPolicy !== "Failure" && responseGetPolicy !== "") {
                                    if (responseGetPolicy !== undefined) {
                                        for (var i = 0; i < responseGetPolicy[0].covers.length; i++) {
                                            var cover = responseGetPolicy[0].covers[i];
                                            if (cover.isMainline === true && (cover.id === IdToUse || cover.riskItems[0].id === IdToUse)) {
                                                coverToUse = cover;
                                                break;
                                            }
                                        };
                                    }
                                    if (coverToUse !== null) {
                                        await dispatch({
                                            type: SET_CUSTOMER_DATA, payload: {
                                                selectedPersonalPolicy: responseGetPolicy[0],
                                                selectedPersonalCover: coverToUse,
                                            }
                                        });
                                    }
                                }
                            } catch (err) {
                                logErrorToDatabase("Error in getPolicyDetails: " + err);
                            }
                        });
                    }
                }).catch((err) => {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    });
                })
            }
            else if (response == true) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: "Sorry the IMEI number already exists",
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE })
        })
    }
}

export const getMobilePaymentSchedule = (debitOrderDate: number) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW });
        if (getState().cart.products.length <= 0)
        {
            dispatch(showModalCalculatorBroke());
        }
        else{
            await postToController(dispatch, 'GetMobilePaymentSchedule', JSON.stringify({
                QuoteId: getState().sales.quoteId,
                QuoteRiskItemId: getState().cart.products[getState().cart.products.length - 1].riskItemId,
                InceptionDate: getState().sales.inceptionDate,
                DebitOrderDay: debitOrderDate
            })).then(async (response) => {
                if (response !== null) {
                    await dispatch({
                        type: SET_QUOTE_DATA, payload: {
                            firstPremium: response.firstPremium,
                            firstPremiumType: response.firstPremiumType,
                            firstPremiumDate: response.firstPremiumDate,
                            premiumTotal: response.premiumTotal,
                        }
                    });
                } else {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: response,
                        }
                    });
                }
            }).catch((err) => {
                logErrorToDatabase("Error addBankingDetailsToQuote, Error: " + err);
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            })
        }
        dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
    }
}

export const getInceptionDate = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'GetMobileQuote', JSON.stringify({
            Parameter: getState().sales.quoteId
        })).then(async (response) => {
            if (response.premiumError){
                dispatch(showModalCalculatorBroke());
            }
            else {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        inceptionDate: response.initiationDate,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error GetMobileQuote, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
    }
}

export const saveBankingDetails = (userData: any) => {
    return async (dispatch, getState) => {
        if (getState().profile.countryId === 157) {
            await dispatch({
                type: SET_QUOTE_DATA, payload: {
                    sourceOfIncomeId: userData.selectedSourceOfIncome.id,
                },
            });
        }
        await dispatch({
            type: SET_QUOTE_DATA, payload: {
                debitOrderDate: userData.selectedDebitDay,
                bankError: false,
                bankName: userData.selectedBank.description,
                accountNumber: userData.accountNumber,
                bankAccountTypeId: userData.selectedAccountType.id,
                bankId: userData.selectedBank.id,
                branchId: userData.selectedBranch.id,
            },
        });
    }
}

export const removeCoverFromQuote = (coverId: any, getCarDetails: boolean = false, isMainline: boolean = false) => {
    return async (dispatch, getState) => {
        var cancelCover: ICancelQuoteCover = {
            cancellationDate: undefined,
            cancellationNote: "SSP Cancel Cover",
            otherInsurerId: undefined,
            primaryCancellationReasonId: Number(getState().sales.primaryQuoteCancellationReason),
            secondaryCancellationReasonId: Number(getState().sales.secondaryQuoteCancellationReason),
            quoteId: getState().sales.quoteId,
            refund: false,
            coverId: coverId,
            quoteCoverIds: [coverId],
            isMainline: isMainline,
        }
        logEvent('SSP_remove_cover_from_quote', getState().sales.quoteId + "/" + coverId);
        await postToController(dispatch, 'CancelQuoteCover', JSON.stringify(
            cancelCover
        )).then(async (responseCancel) => {
            if (responseCancel == 'Failure') {
                throw new Error("");
            }
            else if (getCarDetails) {
                await postToController(dispatch, 'GetCarDetails', JSON.stringify({
                    QuoteId: getState().sales.quoteId,
                    QuoteRiskItemId: getState().sales.carId,
                    RiskItemId: getState().sales.carId,
                })).then(async (carDetailsResponse) => {
                    if (carDetailsResponse.premiumError){
                        dispatch(showModalCalculatorBroke());
                    }
                    else {
                        await postToController(dispatch, 'GetExcessSelection', JSON.stringify({
                            Excess: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                            ExcessId: carDetailsResponse.carDetails.carDetails.excessDetails.excessId,
                            ExcessOptions: carDetailsResponse.carDetails.carDetails.excessDetails.excessOptions,
                        })).then(async (excessResponse) => {
                            await postToController(dispatch, 'GetVapOptions', JSON.stringify({
                                Parameter: getState().profile.countryId,
                            })).then(async (vapOptions) => {
                                if (carDetailsResponse !== null) {
                                    await dispatch({
                                        type: SET_QUOTE_DATA, payload: {
                                            coverId: carDetailsResponse.carDetails.carDetails.quoteCoverId,
                                            carPremium: carDetailsResponse.carDetails.carDetails.premium.toFixed(2),
                                            excessList: excessResponse,
                                            selectedExcess: {
                                                description: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                                                id: carDetailsResponse.carDetails.carDetails.excessDetails.excessId
                                            },
                                            carDetails: carDetailsResponse.carDetails.carDetails,
                                            tyreAndRimOptions: vapOptions.tyreAndRim,
                                            littleDingsOptions: vapOptions.littleDingsAndTyreThings,
                                            carHireOptions: vapOptions.carHire,
                                            balloonOptions: vapOptions.baloonPercentage,
                                            isNewItem: true,
                                            totalPremium: carDetailsResponse.totalPremium
                                        },
                                    });
                                } else {
                                    dispatch({
                                        type: MODAL_SHOW,
                                        modalProps: {
                                            type: MODAL_TYPE_ERROR,
                                            header: ERROR_HEADER,
                                            body: ERROR_SOMETHING_WENT_WRONG,
                                        }
                                    });
                                }
                            }).catch(err => {
                                logErrorToDatabase("Error GetVapOptions in salesActions: " + err);
                            })
                        }).catch(err => {
                            logErrorToDatabase("Error GetExcessSelection in salesActions: " + err);
                        })
                    }
                }).catch(err => {
                    logErrorToDatabase("Error GetCarDetails in salesActions: " + err);
                })
            }
        }).catch((err) => {
            logErrorToDatabase("Error CancelQuoteCover, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
    }
}

export const getQuoteCancellationReasons = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'GetQuoteCancellationReasons', null).then(async (response) => {
            await dispatch({
                type: SET_QUOTE_DATA, payload: {
                    quoteCancellationReasons: response,
                    primaryQuoteCancellationReason: undefined,
                    secondaryQuoteCancellationReason: undefined,
                }
            });

        }).catch((err) => {
            logErrorToDatabase("Error GetQuoteCancellationReasons, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
    }
}

export const setQuoteCancellationReasons = (primaryReason, secondaryReason) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_QUOTE_DATA, payload: {
                primaryQuoteCancellationReason: primaryReason != -1 ? primaryReason : getState().sales.primaryQuoteCancellationReason,
                secondaryQuoteCancellationReason: secondaryReason != -1 ? secondaryReason : getState().sales.secondaryQuoteCancellationReason,
            }
        });
    }
}

export const getBlingNameAndId = (productName) => {
    var response = {
        subDescription: "Brand-new cellphone insurance",
        selectedCoverTypeId: BLING_BRAND_NEW_COVER_TYPE
    };
    if (productName.toLowerCase().includes('like-new')) {
        response = {
            subDescription: "Like-new cellphone insurance",
            selectedCoverTypeId: BLING_LIKE_NEW_COVER_TYPE
        };
    }
    else if (productName.toLowerCase().includes('screen-fix')) {
        response = {
            subDescription: "Screen-fix cellphone insurance",
            selectedCoverTypeId: BLING_SCREEN_FIX_COVER_TYPE
        };
    }
    return response;
}

export const editPolicyRiskItems = (riskItemType, filterItem, skipLoadingScreenShow = false) => {
    return async (dispatch, getState) => {
        if (!skipLoadingScreenShow) { dispatch({ type: LOADING_SCREEN_SHOW }); }
        dispatch({
            type: MODAL_HIDE,
            modalProps: {
                type: MODAL_TYPE_SUCCESS,
                visible: false,
            }
        });
        var cover = getState().profile.selectedPersonalCover;
        var coverId = getState().profile.selectedPersonalCover.id;
        var profileState = getState().profile;
        var selectedBlingCover = getState().profile.selectedPortablePossession;
        var premiumError = false;
        if (riskItemType === AMEND_POLICY_BLING) {
            selectedBlingCover = cover.riskItems[0].blingLikeNewCovers.filter(x => x.id === coverId)[0] ? cover.riskItems[0].blingLikeNewCovers.filter(x => x.id === coverId)[0] : selectedBlingCover;
            selectedBlingCover = cover.riskItems[0].blingScreenFixCovers.filter(x => x.id === coverId)[0] ? cover.riskItems[0].blingScreenFixCovers.filter(x => x.id === coverId)[0] : selectedBlingCover;
            let coverIdDescription = getBlingNameAndId(cover.productName);
            selectedBlingCover.totalPolicyPremium = profileState.selectedPersonalPolicy.totalPolicyPremium;
            selectedBlingCover.subDescription = coverIdDescription.subDescription;
            selectedBlingCover.selectedCoverTypeId = coverIdDescription.selectedCoverTypeId;
        }

        var request = JSON.stringify({
            PolicyId: getState().profile.policyId,
        });
        logEvent('SSP_edit_policy_cover', getState().profile.selectedPersonalCover.id);
        await postToController(dispatch, 'CreateQuoteFromPolicy', request).then(async (response) => {
            if (response === null || response === "Failure" || response.success === false) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                dispatch(navigateTo(DASHBOARD));
            } else {
                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        quoteId: response.quoteId,
                        customerId: response.customerId,
                        quoteNumber: response.quoteNumber
                    }
                });
                if (riskItemType === AMEND_POLICY_CAR) {
                    await postToController(dispatch, 'GetCarDetailsForRiskItem', JSON.stringify({
                        QuoteId: response.quoteId,
                        QuoteRiskItemId: getState().profile.selectedPersonalCover.id,
                        RiskItemId: getState().profile.selectedPersonalCover.id,
                    })).then(async (carDetailsResponse) => {
                        if (carDetailsResponse.premiumError){
                            dispatch(showModalCalculatorBroke());
                            premiumError = true;
                        }
                        else{
                            await postToController(dispatch, 'GetExcessSelection', JSON.stringify({
                                Excess: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                                ExcessId: carDetailsResponse.carDetails.carDetails.excessDetails.excessId,
                                ExcessOptions: carDetailsResponse.carDetails.carDetails.excessDetails.excessOptions
                            })).then(async (excessResponse) => {
                                await postToController(dispatch, 'GetVapOptions', JSON.stringify({
                                    Parameter: getState().profile.countryId,
                                })).then(async (vapOptions) => {
                                    await dispatch({
                                        type: SET_QUOTE_DATA, payload: {
                                            coverId: carDetailsResponse.carDetails.carDetails.quoteCoverId,
                                            carId: carDetailsResponse.riskItemId,
                                            carPremium: carDetailsResponse.carDetails.carDetails.premium,
                                            excessList: excessResponse,
                                            selectedExcess: {
                                                description: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                                                id: carDetailsResponse.carDetails.carDetails.excessDetails.excessId
                                            },
                                            carDetails: carDetailsResponse.carDetails.carDetails,
                                            tyreAndRimOptions: vapOptions.tyreAndRim,
                                            littleDingsOptions: vapOptions.littleDingsAndTyreThings,
                                            carHireOptions: vapOptions.carHire,
                                            balloonOptions: vapOptions.baloonPercentage,
                                            isNewItem: true,
                                            totalPremium: carDetailsResponse.totalPremium,
                                            selectedAgreedValue: carDetailsResponse.carDetails.carDetails.agreedValue,
                                            selectedAgreedValuePercentage: Math.round(((carDetailsResponse.carDetails.carDetails.agreedValue / carDetailsResponse.carDetails.carDetails.retailValue) - 1) * 100)
                                        },
                                    });
                                }).catch(err => {
                                    dispatch({
                                        type: MODAL_SHOW,
                                        modalProps: {
                                            type: MODAL_TYPE_ERROR,
                                            header: ERROR_HEADER,
                                            body: ERROR_SOMETHING_WENT_WRONG,
                                        }
                                    });
                                    logErrorToDatabase("Error GetVapOptions in salesActions: " + err);
                                })
                            }).catch(err => {
                                dispatch({
                                    type: MODAL_SHOW,
                                    modalProps: {
                                        type: MODAL_TYPE_ERROR,
                                        header: ERROR_HEADER,
                                        body: ERROR_SOMETHING_WENT_WRONG,
                                    }
                                });
                                logErrorToDatabase("Error GetExcessSelection in salesActions: " + err);
                            })
                        }
                    }).catch(err => {
                        dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        });
                        logErrorToDatabase("Error GetCarDetails in salesActions: " + err);
                    })
                }
                if (riskItemType === AMEND_POLICY_BLING) {
                    await dispatch(setReplacementValue(selectedBlingCover?.insuredForValue.replace(getState().profile.currencySymbol, "").replaceAll(",", "")));
                    await dispatch(setStartReplacementValue(selectedBlingCover?.insuredForValue.replace(getState().profile.currencySymbol, "").replaceAll(",", "")));
                    await dispatch(setSelectedBlingDetail(selectedBlingCover));
                    await dispatch(getBlingRiskItemDetailedInfo(selectedBlingCover?.id, 1));
                    if (getState().profile.countryId === 157) {
                        selectedBlingCover.subDescription = "Cellphone insurance";
                    }
                }
                else if (riskItemType === AMEND_POLICY_PORTABLE) {
                    await dispatch(setSelectedPortableDetail(filterItem));
                    await dispatch(setReplacementValue(filterItem.insuredForValue));
                    await dispatch(setStartReplacementValue(filterItem.insuredForValue));
                    await dispatch(getPortableRiskItemDetailedInfo(filterItem.id, 1));
                    await dispatch(checkReplacementValue());
                }
                if (!skipLoadingScreenShow) { await dispatch(setIsInEdit(!premiumError)); }
            }
        }).catch(err => {
            logErrorToDatabase("Unable to create policy, Error: " + err)
        }).finally(() => {
            if (!skipLoadingScreenShow) { dispatch({ type: LOADING_SCREEN_HIDE }); }
        })
    }
}

export const removePolicyRiskItems = (riskItemType, filterItem, skipLoadingScreenShow = false) => {
    return async (dispatch, getState) => {
        if (!skipLoadingScreenShow) { dispatch({ type: LOADING_SCREEN_SHOW }); }
        dispatch({
            type: MODAL_HIDE,
            modalProps: {
                type: MODAL_TYPE_SUCCESS,
                visible: false,
            }
        });
        var cover = getState().profile.selectedPersonalCover;
        var coverId = getState().profile.selectedPersonalCover.id;
        var profileState = getState().profile;
        var selectedBlingCover = getState().profile.selectedPortablePossession;
        if (riskItemType === AMEND_POLICY_BLING) {
            selectedBlingCover = cover.riskItems[0].blingLikeNewCovers.filter(x => x.id === coverId)[0] ? cover.riskItems[0].blingLikeNewCovers.filter(x => x.id === coverId)[0] : selectedBlingCover;
            selectedBlingCover = cover.riskItems[0].blingScreenFixCovers.filter(x => x.id === coverId)[0] ? cover.riskItems[0].blingScreenFixCovers.filter(x => x.id === coverId)[0] : selectedBlingCover;
            let coverIdDescription = getBlingNameAndId(cover.productName);
            selectedBlingCover.totalPolicyPremium = profileState.selectedPersonalPolicy.totalPolicyPremium;
            selectedBlingCover.subDescription = coverIdDescription.subDescription;
            selectedBlingCover.selectedCoverTypeId = coverIdDescription.selectedCoverTypeId;
        }

        var request = JSON.stringify({
            PolicyId: getState().profile.policyId,
        });
        logEvent('SSP_edit_policy_cover', getState().profile.selectedPersonalCover.id);
        await postToController(dispatch, 'CreateQuoteFromPolicyCancelCover', request).then(async (response) => {
            if (response === null || response === "Failure" || response.success === false) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                dispatch(navigateTo(DASHBOARD));
            } else {
                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        quoteId: response.quoteId,
                        customerId: response.customerId,
                        quoteNumber: response.quoteNumber
                    }
                });
                if (riskItemType === AMEND_POLICY_CAR) {
                    await postToController(dispatch, 'GetCarDetailsForRiskItem', JSON.stringify({
                        QuoteId: response.quoteId,
                        QuoteRiskItemId: getState().profile.selectedPersonalCover.id,
                        RiskItemId: getState().profile.selectedPersonalCover.id,
                    })).then(async (carDetailsResponse) => {
                        if (carDetailsResponse.premiumError){
                            dispatch(showModalCalculatorBroke());
                        }
                        else{
                            await postToController(dispatch, 'GetExcessSelection', JSON.stringify({
                                Excess: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                                ExcessId: carDetailsResponse.carDetails.carDetails.excessDetails.excessId,
                                ExcessOptions: carDetailsResponse.carDetails.carDetails.excessDetails.excessOptions
                            })).then(async (excessResponse) => {
                                await postToController(dispatch, 'GetVapOptions', JSON.stringify({
                                    Parameter: getState().profile.countryId,
                                })).then(async (vapOptions) => {
                                    await dispatch({
                                        type: SET_QUOTE_DATA, payload: {
                                            coverId: carDetailsResponse.carDetails.carDetails.quoteCoverId,
                                            carId: carDetailsResponse.riskItemId,
                                            carPremium: carDetailsResponse.carDetails.carDetails.premium,
                                            excessList: excessResponse,
                                            selectedExcess: {
                                                description: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                                                id: carDetailsResponse.carDetails.carDetails.excessDetails.excessId
                                            },
                                            carDetails: carDetailsResponse.carDetails.carDetails,
                                            tyreAndRimOptions: vapOptions.tyreAndRim,
                                            littleDingsOptions: vapOptions.littleDingsAndTyreThings,
                                            carHireOptions: vapOptions.carHire,
                                            balloonOptions: vapOptions.baloonPercentage,
                                            isNewItem: true,
                                            totalPremium: carDetailsResponse.totalPremium,
                                            selectedAgreedValue: carDetailsResponse.carDetails.carDetails.agreedValue,
                                            selectedAgreedValuePercentage: Math.round(((carDetailsResponse.carDetails.carDetails.agreedValue / carDetailsResponse.carDetails.carDetails.retailValue) - 1) * 100)
                                        },
                                    });
                                }).catch(err => {
                                    dispatch({
                                        type: MODAL_SHOW,
                                        modalProps: {
                                            type: MODAL_TYPE_ERROR,
                                            header: ERROR_HEADER,
                                            body: ERROR_SOMETHING_WENT_WRONG,
                                        }
                                    });
                                    logErrorToDatabase("Error GetVapOptions in salesActions: " + err);
                                })
                            }).catch(err => {
                                dispatch({
                                    type: MODAL_SHOW,
                                    modalProps: {
                                        type: MODAL_TYPE_ERROR,
                                        header: ERROR_HEADER,
                                        body: ERROR_SOMETHING_WENT_WRONG,
                                    }
                                });
                                logErrorToDatabase("Error GetExcessSelection in salesActions: " + err);
                            })
                        }
                    }).catch(err => {
                        dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        });
                        logErrorToDatabase("Error GetCarDetails in salesActions: " + err);
                    })
                }
                if (riskItemType === AMEND_POLICY_BLING) {
                    await dispatch(setReplacementValue(selectedBlingCover?.insuredForValue.replace(getState().profile.currencySymbol, "").replaceAll(",", "")));
                    await dispatch(setStartReplacementValue(selectedBlingCover?.insuredForValue.replace(getState().profile.currencySymbol, "").replaceAll(",", "")));
                    await dispatch(setSelectedBlingDetail(selectedBlingCover));
                    await dispatch(getBlingRiskItemDetailedInfo(selectedBlingCover?.id, 1));
                    if (getState().profile.countryId === 157) {
                        selectedBlingCover.subDescription = "Cellphone insurance";
                    }
                }
                else if (riskItemType === AMEND_POLICY_PORTABLE) {
                    await dispatch(setSelectedPortableDetail(filterItem));
                    await dispatch(setReplacementValue(filterItem.insuredForValue));
                    await dispatch(setStartReplacementValue(filterItem.insuredForValue));
                    await dispatch(getPortableRiskItemDetailedInfo(filterItem.id, 1));
                    await dispatch(checkReplacementValue());
                }
                if (!skipLoadingScreenShow) { await dispatch(setIsInEdit(true)); }
            }
        }).catch(err => {
            logErrorToDatabase("Unable to create policy, Error: " + err)
        }).finally(() => {
            if (!skipLoadingScreenShow) { dispatch({ type: LOADING_SCREEN_HIDE }); }
        })
    }
}

export const getQuoteMobilePaymentSchedule = (skipLoadingScreen = false) => {
    return async (dispatch, getState) => {
        if (!skipLoadingScreen) { dispatch({ type: QUOTE_LOADING_SCREEN_SHOW }); }
        await postToController(dispatch, 'GetMobilePaymentSchedule', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            QuoteRiskItemId: getState().sales.carId,
            DebitOrderDay: getState().profile.selectedPersonalPolicy.debitOrderDay
        })).then(async (response) => {
            if (response !== null) {
                if (response.firstPremiumType.toLowerCase() == 'credit') {
                    await dispatch({
                        type: SET_QUOTE_DATA, payload: {
                            creditAmount: response.firstPremium,
                            updatedPremium: response.premiumTotal,
                            proRata: response.firstPremium,
                            totalPremium: response.premiumTotal
                        }
                    });
                }
                else {
                    await dispatch({
                        type: SET_QUOTE_DATA, payload: {
                            creditAmount: 0,
                            updatedPremium: response.premiumTotal,
                            proRata: response.firstPremium,
                            totalPremium: response.premiumTotal,
                        }
                    });
                }
            } else {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: response,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error addBankingDetailsToQuote, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
        if (!skipLoadingScreen) { dispatch({ type: QUOTE_LOADING_SCREEN_HIDE }); }
    }
}

export const removeVehicleFromPolicy = () => {
    return async (dispatch, getState) => {
        logEvent('SSP_remove_cover_from_policy', getState().profile.selectedPersonalCover.id);
        await dispatch({ type: UPDATE_POLICY_LOADER_SCREEN_SHOW });
        var riskItemDescription = getState().profile.selectedPersonalCover.riskItems[0].description
        await dispatch(removePolicyRiskItems(AMEND_POLICY_CAR, 1, true));
        await dispatch(removeCoverFromQuote(getState().sales.carDetails.quoteCoverId, false, true));
        await dispatch(getQuoteMobilePaymentSchedule(true));

        var premiums = {
            firstPremium: getState().sales.firstPremium,
            premiumTotal: getState().sales.premiumTotal,
        };
        var riskItemId = getState().sales.carDetails.quoteCoverId;
        if ((getState().profile.selectedPersonalCover.productName.toLowerCase() == 'car' || getState().profile.selectedPersonalCover.productName.toLowerCase() == 'motorbike')) {
            var selectedCover = getState().profile.selectedPersonalCover;
            var allCovers = getState().profile.selectedPersonalPolicy.covers;
            var mainlineNames = 'car motorbike home contents bling building'
            var mainlineNamesAndStandAlone = 'car motorbike home contents building warranty code red other'
            var dependentCovers = allCovers.filter(x => !mainlineNamesAndStandAlone.includes(x.productName.toLowerCase()))
            var otherMainlines = allCovers.filter(x => x.id !== selectedCover.id && mainlineNames.includes(x.productName.toLowerCase()));
            var onlyOneRiskItem = getState().profile.selectedPersonalPolicy.covers.find(x => x.riskItems[0].id !== selectedCover.id && x.productName.toLowerCase() != 'other');
            if (!onlyOneRiskItem || (onlyOneRiskItem && onlyOneRiskItem.length == 0)) {
                await dispatch({ type: UPDATE_POLICY_LOADER_SCREEN_HIDE });
                dispatch(setIsInEditRemove(false));
                dispatch(showRetentionsModal());
                return;
            }
            if (!otherMainlines || (otherMainlines && otherMainlines.length == 0)) {
                var dependents = "";
                var copy = "isn't a stand-alone product, it'll also be removed when you remove";
                if (dependentCovers.length > 0) {
                    if (dependentCovers.length == 1) {
                        dependents = dependentCovers[0].productName + " insurance";
                    }
                    else {
                        copy = "aren't stand-alone products, they'll also be removed when you remove";
                        for (var i = 0; i < dependentCovers.length; i++) {
                            if (!dependents.includes(dependentCovers[i].productName) && dependentCovers[i].productName.toLowerCase() !== "other") {
                                dependents = (i == 0 ? " and " : (i == dependentCovers.length - 1 ? "" : ", ")) + dependentCovers[i].productName + dependents;
                            }
                        }
                        dependents += " insurance";
                        if (dependents.startsWith(",")) {
                            dependents = dependents.substring(1)
                        }
                    }
                    dispatch(setIsInEditRemove(false));
                    await dispatch({ type: UPDATE_POLICY_LOADER_SCREEN_HIDE });
                    dispatch(showRetentionsWithDependentsModal(dependents, copy, getState().profile.selectedPersonalCover.productName + " insurance"))
                }
                else {
                    dispatch(setIsInEditRemove(false));
                    await dispatch({ type: UPDATE_POLICY_LOADER_SCREEN_HIDE });
                    dispatch(showRetentionsModal());
                }
                return;
            }
        }
        dispatch(setIsInEditRemove(false));
        if (getState().modal.modalProps?.type != MODAL_TYPE_ERROR) {
            await dispatch(updatePolicy());
            if (getState().modal.modalProps?.type != MODAL_TYPE_ERROR) {
                if (getState().ssp.sendRemovalEmail) {
                    await dispatch(sendRemovalEmail(getState().profile.personalPolicies[0].policyNumber,riskItemDescription));
                }
                await dispatch(showCoverRemovedModal(premiums.firstPremium, premiums.premiumTotal, "Car insurance", riskItemDescription));
            }
            else {
                await dispatch(navigateTo(DASHBOARD));
            }
        }
        else {
            await dispatch(navigateTo(DASHBOARD));
        }
        await dispatch({ type: UPDATE_POLICY_LOADER_SCREEN_HIDE });
    }
}

export const sendRemovalEmail = (policyNumber: string, coverDesription: string) => {
    return async (dispatch) => {
        await postToController(dispatch, 'SendRemoveCoverEmail', JSON.stringify({
            PolicyNumber: policyNumber,
            CoverDescription: coverDesription,
        }))
    }
}

export const removeVapFromQuoteWithReasons = (quoteCoverId: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: MODAL_HIDE,
            modalProps: {
                type: MODAL_TYPE_SUCCESS,
                visible: false,
            }
        });
        await dispatch({ type: UPDATE_POLICY_LOADER_SCREEN_SHOW });
        await dispatch(removeCoverFromQuote(quoteCoverId, true));
        await dispatch({ type: UPDATE_POLICY_LOADER_SCREEN_HIDE });
    }
}

export const setSalesReducer = (type, name, value) => {
    return async (dispatch) => {
        await dispatch({
            type: type, payload: {
                [name]: value
            }
        });
    }
}

export const addToBlingNumbers = () => {
    return (dispatch, getState) => {
        var acceptedNumbers = getState().sales.addedBlingNumbers;
        var numberToAdd = getState().sales.riskItemPhonenumber
        if (acceptedNumbers == undefined) {
            acceptedNumbers = []
        }
        acceptedNumbers.push(numberToAdd)
        dispatch(setSalesReducer(SET_QUOTE_DATA, 'addedBlingNumbers', acceptedNumbers))
    }
}

export const removeFromBlingNumbers = (item) => {
    return (dispatch, getState) => {

        var acceptedNumbers = getState().sales.addedBlingNumbers;
        if (acceptedNumbers == undefined) {
            acceptedNumbers = []
        }
        acceptedNumbers = acceptedNumbers.filter(x => x != item)
        dispatch(setSalesReducer(SET_QUOTE_DATA, 'addedBlingNumbers', acceptedNumbers))
    }
}

//Sales process steps for Code red 
export const initiateCodeRedSteps = () => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_STEPS_CODE_RED, payload: {
            }
        });

        await dispatch({
            type: SET_QUOTE_DATA, payload: {
                name: getState().profile.name,
                surname: getState().profile.surname,
                cellphoneNumber: getState().profile.cellphoneNumber,
                email: getState().profile.email,
            }
        });
    }
}

export const setSalesStep = (selectedStep: any) => {
    return async (dispatch) => {
        await dispatch({
            type: SET_QUOTE_DATA, payload: {
                selectedSalesStep: selectedStep,
                saleStep: selectedStep.step,
                saleSubStep: selectedStep.subStep
            }
        });
    }
}

export const setStep = (step: number, subStep: number = 1) => {
    return async (dispatch, getState) => {
        let currentStep = getState().sales.salesStepConfiguration.steps.filter(x => x.step === step)[0];
        if (isMobile) {
            if (currentStep.maxMobileSubSteps < subStep) {
                currentStep.subStep = currentStep.maxMobileSubSteps;
                subStep = currentStep.maxMobileSubSteps;
            }
            else {
                currentStep.subStep = subStep;
            }
        }
        else {
            if (currentStep.maxSubSteps < subStep) {
                currentStep.subStep = currentStep.maxSubSteps;
                subStep = currentStep.maxSubSteps;
            }
            else {
                currentStep.subStep = subStep;
            }
        }
        await dispatch(setSalesStep(currentStep));
    }
}

export const completeStep = () => {
    return async (dispatch, getState) => {
        var step = getState().sales.selectedSalesStep.step;

        var subStep = getState().sales.selectedSalesStep.subStep;
        var lastStep = getState().sales.lastCompletedStep;
        var lastSubStep = getState().sales.lastCompletedSubStep;
        if (step + (subStep / 10) > lastStep + (lastSubStep / 10)) {
            lastStep = step;
            lastSubStep = subStep;
        }
        dispatch({
            type: SET_STEPS_CODE_RED, payload: {
                lastCompletedStep: lastStep,
                lastCompletedSubStep: lastSubStep
            }
        });
    }
}

export const handleNextStep = () => {
    return async (dispatch, getState) => {
        let currentStep = getState().sales.selectedSalesStep;
        if ((!isMobile && currentStep.subStep < currentStep.maxSubSteps) || (isMobile && currentStep.subStep < currentStep.maxMobileSubSteps)) {
            currentStep.subStep++;
        }
        else if ((!isMobile && (currentStep.subStep >= currentStep.maxSubSteps || currentStep.maxSubSteps === 0)) || (isMobile && ((currentStep.subStep >= currentStep.maxMobileSubSteps || currentStep.maxMobileSubSteps === 0)))) {
            for (var i = 0; i < getState().sales.salesStepConfiguration.steps.length; i++) {
                if (getState().sales.salesStepConfiguration.steps[i].step === currentStep.step) {
                    currentStep = getState().sales.salesStepConfiguration.steps[i + 1];
                    break;
                }
            }
        }
        if (((isMobile && currentStep.maxMobileSubSteps === 0) || (!isMobile && currentStep.maxSubSteps === 0)) && (currentStep.title !== 'Complete' && currentStep.title !== 'Finalise details')) {
            await dispatch(setSalesStep(currentStep));
            dispatch(handleNextStep());
        }
        else {
            dispatch(setSalesStep(currentStep));
        }
    }
}

export const handlePreviousSalesStep = (retainSubsteps: boolean = true) => {
    return async (dispatch, getState) => {
        let currentStep = getState().sales.selectedSalesStep;

        if (currentStep.subStep > 1 && retainSubsteps) {
            currentStep.subStep--;
            await dispatch(setSalesStep(currentStep));
        }
        else if (currentStep.subStep === 1 || !retainSubsteps) {
            currentStep = getState().sales.salesStepConfiguration.steps[getState().sales.salesStepConfiguration.steps.indexOf(getState().sales.salesStepConfiguration.steps.filter(x => x.step === (currentStep.step))[0]) - 1]
            if (currentStep === undefined) {
                await dispatch(navigateTo(DASHBOARD));
            }

            if (retainSubsteps) {
                currentStep.subStep = !isMobile ? currentStep.maxSubSteps : currentStep.maxMobileSubSteps;
            }
            else {
                currentStep.subStep = 1;
            }

            if ((!isMobile && currentStep.maxSubSteps === 0) || (isMobile && currentStep.maxMobileSubSteps === 0)) {
                await dispatch(setSalesStep(currentStep));
                await dispatch(handlePreviousSalesStep());
            } else {
                await dispatch(setSalesStep(currentStep));
            }
        }
    }
}

export const addCodeRedToQuote = () => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        var success = true;
        logEvent('SSP_add_code_red_to_quote', getState().sales.quoteId);
        await postToController(dispatch, 'AddEmergencyServiceToQuote', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            QuoteSource: undefined,
            UnderwritingType: undefined,
            EmergencyServiceMembers: [{
                MmCode: getState().sales.mmCode,
                VehicleModelId: getState().sales.vehicleModelId,
                VehicleMakeId: getState().sales.vehicleMakeId,
                VehicleSeriesId: getState().sales.vehicleSeriesId,
                VehicleYear: getState().sales.vehicleYear,
                RegistrationNumber: getState().sales.regNr,
                CarColour: Number(getState().sales.carColor.id),
                LinkRiskItemId: getState().sales.codeRedSelectedRiskitem === "" ? undefined : getState().sales.codeRedSelectedRiskitem
            }],
            ShouldReply: true,
        })).then(async (coverDetails) => {
            if (coverDetails !== "Failure" && coverDetails !== null && coverDetails !== '') {
                await postToController(dispatch, 'AddCodeRedCoverToQuote', JSON.stringify({
                    AddCoverToQuote: {
                        QuoteId: getState().sales.quoteId,
                        QuoteRiskItemId: coverDetails.result.emergencyServiceId,
                        ProductId: CODE_RED_PRODUCT_GUID,
                        InceptionDate: undefined,
                        ValueAddedProductItemId: undefined,
                        HailCover: undefined,
                        RatingsEffectiveDate: undefined,
                        ConsentToGetMultiItemDiscount: undefined,
                        ProductExcessId: undefined,
                        Excess: undefined
                    },
                    EmergencyServiceQuoteDetailsRequest: {
                        QuoteId: getState().sales.quoteId,
                        QuoteRiskItemId: coverDetails.result.emergencyServiceId,
                    }
                })).then(async (response) => {
                    if (response.premium === 0) {
                        await dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        });
                        dispatch(navigateTo(DASHBOARD))
                    }
                    else {
                        await dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                quoteScreenRiskId: response.quoteRiskItemId,
                                quoteScreenRiskDescription: getState().sales.vehicleFullDescription,
                                carPremium: response.emergencyServicePremium.toFixed(2),
                                proRata: response.emergencyServicePremium.toFixed(2),
                            }
                        });
                    }
                })
            }
            else {
                success = false;
            }
        }).catch((err) => {
            logErrorToDatabase("Error adding code red vehicle to quote, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            if (success) {
                dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_HIDE });
                    dispatch(navigateTo(QUOTATION))
                    dispatch({
                        type: SET_QUOTE_DATA, payload: {
                            isQuoteScreen: true,
                        }
                    });

                }, 1000);
            }
            else {
                dispatch(navigateTo(DASHBOARD))
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        })
    }
}

export const addCodeRedNoVehicleToQuote = () => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        var success = true;
        logEvent('SSP_add_code_red_to_quote', getState().sales.quoteId);
        await postToController(dispatch, 'AddEmergencyServiceToQuote', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            QuoteSource: undefined,
            UnderwritingType: undefined,
            EmergencyServiceMembers: [],
            ShouldReply: true,
        })).then(async (coverDetails) => {
            if (coverDetails !== "Failure" && coverDetails !== null && coverDetails !== '') {
                await postToController(dispatch, 'AddCodeRedCoverToQuote', JSON.stringify({
                    AddCoverToQuote: {
                        QuoteId: getState().sales.quoteId,
                        QuoteRiskItemId: coverDetails.result.emergencyServiceId,
                        ProductId: CODE_RED_PRODUCT_GUID,
                        InceptionDate: undefined,
                        ValueAddedProductItemId: undefined,
                        HailCover: undefined,
                        RatingsEffectiveDate: undefined,
                        ConsentToGetMultiItemDiscount: undefined,
                        ProductExcessId: undefined,
                        Excess: undefined
                    },
                    EmergencyServiceQuoteDetailsRequest: {
                        QuoteId: getState().sales.quoteId,
                        QuoteRiskItemId: coverDetails.result.emergencyServiceId,
                    }
                })).then(async (response) => {
                    if (response === "Failure" || response === null) {
                        await dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        });
                        dispatch(navigateTo(DASHBOARD))
                        success = false;
                    }
                    else {
                        await dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                quoteScreenRiskId: response.quoteRiskItemId,
                                quoteScreenRiskDescription: getState().sales.vehicleFullDescription,
                                carPremium: response.emergencyServicePremium.toFixed(2),
                                proRata: response.emergencyServicePremium.toFixed(2),
                            }
                        });
                    }
                })
            }
            else {
                success = false;
            }
        }).catch((err) => {
            logErrorToDatabase("Error adding code red no vehicle to quote, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            if (success) {
                dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_HIDE });
                    dispatch(navigateTo(QUOTATION))
                    dispatch({
                        type: SET_QUOTE_DATA, payload: {
                            isQuoteScreen: true,
                        }
                    });
                }, 1000);
            }
            else {
                dispatch(navigateTo(DASHBOARD))
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        })
    }
}

//Sales process steps for Warranty
export const initiateWarrantySteps = () => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_STEPS_WARRANTY, payload: {
            }
        });
        await dispatch({
            type: PRODUCT_CAR_WARRANTY, payload: {
            }
        });

        await dispatch({
            type: SET_QUOTE_DATA, payload: {
                name: getState().profile.name,
                surname: getState().profile.surname,
                cellphoneNumber: getState().profile.cellphoneNumber,
                email: getState().profile.email,
            }
        })
    }
}

export const addWarrantyToQuote = () => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        var success = true;
        let jsonObject = JSON.stringify({
            QuoteId: getState().sales.quoteId,
            CarRegisteredLocally: getState().sales.carRegisteredLocally === true ? 1 : 0,
            PerformanceModification: getState().sales.performanceModification === true ? 1 : 0,
            FullServiceHistory: getState().sales.fullServiceHistory === true ? 1 : 0,
            ExistingWarranty: getState().sales.existingWarranty === true ? 1 : 0,
            ApproximateMileage: Number(getState().sales.kilometersOnCar),
            MonthlyMileageId: getState().sales.averageKilometers,
            Year: Number(getState().sales.vehicleYear),
            VehicleMakeId: getState().sales.vehicleMakeId,
            VehicleModelId: getState().sales.vehicleModelId,
            VehicleSeriesId: getState().sales.vehicleSeriesId,
            MmCode: getState().sales.mmCode,
            RegistrationNumber: getState().sales.regNr,
            VinNumber: getState().sales.vinNumber,
            EngineNumber: getState().sales.engineNumber,
        })
        logEvent('SSP_add_warranty_to_quote', getState().sales.quoteId);
        await postToController(dispatch, 'AddWarrantyToQuote', jsonObject).then(async (response) => {
            if (response !== "Failure" && response !== null) {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        warrantyBenefits: response.warrantyBenefits,
                        carPremium: response.warrantyPremium.toFixed(2),
                        carWarrantyValueDisplay: response.carValueDisplay,
                        carWarrantyMaxMilage: response.maxMilage,
                    }
                });
            }
        }).catch((err) => {
            logErrorToDatabase("Error adding warranty to quote, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            if (success) {
                dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_HIDE });
                    dispatch(navigateTo(QUOTATION))
                    dispatch({
                        type: SET_QUOTE_DATA, payload: {
                            isQuoteScreen: true,
                        }
                    });
                }, 1000);
            }
            else {
                dispatch(navigateTo(DASHBOARD))
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        })
    }
}

export const updateCarCover = (swapToAgreed: boolean, navigateToQuote: boolean) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        let success = true;
        let agreedValue = 0;

        let productSwap = COMPREHENSIVE_CAR_COVER_TYPE
        if (swapToAgreed) {
            productSwap = AGREED_VALUE_COVER_TYPE
        }

        if (getState().sales.selectedAgreedValue !== null && !navigateToQuote) {
            agreedValue = Number(getState().sales.selectedAgreedValue)
        }
        logEvent('SSP_update_car_cover', getState().sales.quoteId + "/" + getState().sales.carId);
        await postToController(dispatch, 'UpdateCarCoverOnQuote', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            CarId: getState().sales.carId,
            ProductId: productSwap,
            AgreedValue: swapToAgreed ? agreedValue === 0 ? undefined : agreedValue : undefined,
            CountryId: getState().profile.countryId,
        })).then(async (response) => {
            if (response !== "Failure" && response !== null) {
                await postToController(dispatch, 'GetCarDetails', JSON.stringify({
                    QuoteId: getState().sales.quoteId,
                    QuoteRiskItemId: getState().sales.carId,
                    RiskItemId: getState().sales.carId,
                })).then(async (carDetailsResponse) => {
                    await postToController(dispatch, 'GetExcessSelection', JSON.stringify({
                        Excess: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                        ExcessId: carDetailsResponse.carDetails.carDetails.excessDetails.excessId,
                        ExcessOptions: carDetailsResponse.carDetails.carDetails.excessDetails.excessOptions,
                    })).then(async (excessResponse) => {
                        await postToController(dispatch, 'GetVapOptions', JSON.stringify({
                            Parameter: getState().profile.countryId,
                        })).then(async (vapOptions) => {
                            await dispatch({
                                type: SET_QUOTE_DATA, payload: {
                                    coverId: response.result.coverId,
                                    carPremium: carDetailsResponse.carDetails.carDetails.premium.toFixed(2),
                                    proRata: carDetailsResponse.quote.proRate,
                                    quote: carDetailsResponse.quote,
                                    excessList: excessResponse,
                                    selectedExcess: {
                                        description: carDetailsResponse.carDetails.carDetails.excessDetails.excess,
                                        id: carDetailsResponse.carDetails.carDetails.excessDetails.excessId
                                    },
                                    carDetails: carDetailsResponse.carDetails.carDetails,
                                    tyreAndRimOptions: vapOptions.tyreAndRim,
                                    littleDingsOptions: vapOptions.littleDingsAndTyreThings,
                                    carHireOptions: vapOptions.carHire,
                                    balloonOptions: vapOptions.baloonPercentage,
                                    isNewItem: true,
                                    totalPremium: carDetailsResponse.totalPremium,
                                    selectedAgreedValue: carDetailsResponse.carDetails.carDetails.agreedValue,
                                    selectedAgreedValuePercentage: swapToAgreed ? Math.round(((carDetailsResponse.carDetails.carDetails.agreedValue / carDetailsResponse.carDetails.carDetails.retailValue) - 1) * 100) : null
                                },
                            });
                        }).catch(err => {
                            success = false;
                            logErrorToDatabase("Error GetVapOptions in salesActions: " + err);
                        })
                    }).catch(err => {
                        success = false;
                        logErrorToDatabase("Error GetExcessSelection in salesActions: " + err);
                    })
                }).catch(err => {
                    success = false;
                    logErrorToDatabase("Error GetCarDetails in salesActions: " + err);
                })
            }
        }).catch((err) => {
            logErrorToDatabase("Error updating cover on quote, Error: " + err);
        }).finally(() => {
            dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
            if (success) {
                dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_HIDE });
                    if (navigateToQuote) {
                        dispatch(navigateTo(QUOTATION))
                        dispatch({
                            type: SET_QUOTE_DATA, payload: {
                                isQuoteScreen: true,
                            }
                        });
                    }
                }, 1000);
            }
            else {
                dispatch(navigateTo(DASHBOARD))
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }
        })
    }
}

//Submit Building
export const addHomeContentOrBuildingToQuote = () => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })
        let eventType = 'SSP_add_building_to_quote'
        let filterValue = BUILDING_CLAIM_TYPE_ID;
        let productId = BUILDING_COMPREHENSIVE_PRODUCT_GUID
        if (getState().sales.quoteType === PRODUCT_HOME_CONTENT) {
            productId = HOME_CONTENT_COMPREHENSIVE_PRODUCT_GUID
            eventType = 'SSP_add_home_content_to_quote'
            filterValue = CONTENT_CLAIM_TYPE_ID;
        }
        logEvent(eventType, getState().sales.quoteId);
        let propertyBorders: IPropertyBorders[] = [];
        if (getState().sales.propertyBorders.field) {
            propertyBorders.push({ propertyBorderId: BUILDING_BORDER_FIELD_ID, isActive: true } as IPropertyBorders)
        }
        if (getState().sales.propertyBorders.river) {
            propertyBorders.push({ propertyBorderId: BUILDING_BORDER_RIVER_ID, isActive: true } as IPropertyBorders)
        }
        if (getState().sales.propertyBorders.informalSettlement) {
            propertyBorders.push({ propertyBorderId: BUILDING_BORDER_INFORMAL_ID, isActive: true } as IPropertyBorders)
        }
        if (getState().sales.propertyBorders.farmPlot) {
            propertyBorders.push({ propertyBorderId: BUILDING_BORDER_PLOT_ID, isActive: true } as IPropertyBorders)
        }

        let addressClaims: IClaimsAddress[] = [];
        getState().sales.claimsHistory.forEach((item) => {
            if (!item.isExisting && item.claimType === filterValue) {
                addressClaims.push({
                    IncidentTypeId: Number(item.lossType),
                    InsuranceCompanyId: BUILDING_UNKNOWN_INSURER,
                    DateOfLoss: item.date,
                    ClaimValue: Number(item.value.replaceAll(",", "")),
                    CurrentPremises: item.currentPremises,
                    RiskItemTypeId: item.claimType,
                    AddressId: getState().sales.addressId,
                } as IClaimsAddress);
            }
        });
        await postToController(dispatch, 'AddBuildingContentsToQuote', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            ProductId: productId,
            AddressClaims: addressClaims,
            BuildingAddressId: getState().sales.addressId,
            BuildingOccupantId: getState().sales.buildingLiving,
            BuildingUsageId: getState().sales.buildingUse,
            IsFinanced: getState().sales.financed,
            BuildingFinancedHouseId: getState().sales.financed ? getState().sales.financeHouseId : undefined,
            HomeAgeId: getState().sales.buildingAge,
            BedroomId: getState().sales.buildingInfo.bedrooms,
            GeyserId: getState().sales.buildingInfo.geysers,
            HasSecurityEstate: getState().sales.buildingInfo.securityEstate,
            HasAlarmLinked: getState().sales.buildingInfo.armedResponse,
            HasBurglarBars: getState().sales.buildingInfo.burglarBars,
            HasElectricFence: getState().sales.buildingInfo.electricFence,
            PropertyBorders: propertyBorders.length > 0 ? propertyBorders : undefined,
            HasThatchRoof: getState().sales.buildingAdditional.thatchRoof,
            HasThatchLapa: getState().sales.buildingAdditional.thatchLapa,
            HasWoodenWalls: getState().sales.buildingAdditional.woodenWalls,
            HasAlternativePower: getState().sales.buildingAdditional.alternativePower,
            HasLightningConductor: getState().sales.buildingAdditionalDetail.thatch_lightningConductor,
            HasFireRedardent: getState().sales.buildingAdditionalDetail.thatch_fireRetardantTreatment,
            HasFireExtinguisher: false,
            HasHarveyTiles: false,
            LapaDistance: getState().sales.buildingAdditional.thatchLapa ? getState().sales.buildingAdditionalDetail.thatch_distanceBetween : 0,
            AlternativeReplacementValue: getState().sales.buildingAdditional.alternativePower ? Number(getState().sales.buildingAdditionalDetail.alternativePower_replacementValue.replaceAll(",", "")) : 0,
            InsuredValue: Number(getState().sales.buildingReplacementValue),
            HasPreviousComprehensiveInsurer: getState().sales.currentlyInsured,
            ClaimCountId: getState().sales.claimsSelection.id,
            BuildingFinishId: getState().sales.buildingRating,
        })
        ).then(async response => {
            if (response && response !== "Failure") {
                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        coverId: response.result.coverId,
                        carPremium: response.result.riskitemPremium,
                        proRata: response.result.proRata,
                        selectedExcess: response.result.excessAmount,
                        carId: response.result.riskitemId,
                        isNewItem: true,
                    },
                });

                dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });

                dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_HIDE });
                    dispatch(navigateTo(QUOTATION))
                    dispatch({
                        type: SET_QUOTE_DATA, payload: {
                            isQuoteScreen: true,
                        }
                    });
                }, 1000);
            }
            else {
                dispatch(navigateTo(DASHBOARD))
                throw new Error("Error post addHomeContentOrBuildingToQuote > response Failure");
            }
        }).catch(err => {
            logErrorToDatabase("Error post addHomeContentOrBuildingToQuote, Error: " + err);
        });
        dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
    }
}

export const updateHomeContentOrBuildingToQuote = (productId: string, replacementValue: number) => {
    return async (dispatch, getState) => {
        dispatch({ type: QUOTE_LOADING_SCREEN_SHOW })

        let eventType = 'SSP_update_building_to_quote'
        if (getState().sales.quoteType === PRODUCT_HOME_CONTENT) {
            eventType = 'SSP_update_home_content_to_quote'
        }
        logEvent(eventType, getState().sales.quoteId);

        await postToController(dispatch, 'UpdateBuildingContentOnQuote', JSON.stringify({
            QuoteId: getState().sales.quoteId,
            ProductId: productId,
            RiskItemId: getState().sales.carId,
            InsuredValue: Number(replacementValue),
            CountryId: getState().profile.countryId,
        })
        ).then(async response => {
            if (response && response !== "Failure") {
                await dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        carPremium: response.result.riskitemPremium,
                        coverId: response.result.coverId,
                        selectedExcess: response.result.excessAmount,
                    },
                });
                dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });

                dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_SHOW });
                setTimeout(() => {
                    dispatch({ type: POLICY_VIEW_SUCCESS_SCREEN_HIDE });
                    dispatch({
                        type: SET_QUOTE_DATA, payload: {
                            isQuoteScreen: true,
                        }
                    });
                }, 1000);
            }
            else {
                dispatch(navigateTo(DASHBOARD))
                throw new Error("Error post CreateCustomerAddress > response Failure")
            };
        }).catch(err => {
            logErrorToDatabase("Error post CreateCustomerAddress, Error: " + err);
        });
        dispatch({ type: QUOTE_LOADING_SCREEN_HIDE });
    }
}

export const initiateBuildingSteps = () => {
    return async (dispatch, getState) => {
        if (getState().sales.quoteId === "") {
            await dispatch({ type: RESET_QUOTE_DATA, payload: {} });
        }
        await dispatch({ type: PRODUCT_BUILDING, payload: {} });
        await dispatch({ type: SET_STEPS_BUILDING, payload: {} });
    }
}

export const initiateHomeContentSteps = () => {
    return async (dispatch, getState) => {
        if (getState().sales.quoteId === "") {
            await dispatch({ type: RESET_QUOTE_DATA, payload: {} });
        }
        await dispatch({ type: PRODUCT_HOME_CONTENT, payload: {} });
        await dispatch({ type: SET_STEPS_HOME_CONTENT, payload: {} });
    }
}

export const switchToHomeContent = () => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_QUOTE_DATA,
            payload: {
                quoteType: PRODUCT_HOME_CONTENT,
                addProduct: PRODUCT_HOME_CONTENT,
                claimsCount: undefined,
                claimsHistory: [],
                claimsSelection: undefined,
                buildingReplacementValue: undefined,
            }
        });
        dispatch({ type: SET_STEPS_HOME_CONTENT_PARTIAL, payload: {} });
        dispatch(navigateTo(BUILDING_AND_CONTENT_JOURNEY_BUILDER));
    }
}

export const switchToBuilding = () => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_QUOTE_DATA,
            payload: {
                quoteType: PRODUCT_BUILDING,
                addProduct: PRODUCT_BUILDING,
                claimsCount: undefined,
                claimsHistory: [],
                claimsSelection: undefined,
                buildingReplacementValue: undefined,
            }
        });
        dispatch({ type: SET_STEPS_BUILDING_PARTIAL, payload: {} });
        dispatch(navigateTo(BUILDING_AND_CONTENT_JOURNEY_BUILDER));
    }
}

export const loadAllAddresses = () => {
    return async (dispatch, getState) => {
        let dataSet: any[] = [];
        await postToController(dispatch, 'GetAddressByCustomerId', JSON.stringify({
            Parameter: getState().sales.customerId !== "" ? getState().sales.customerId : getState().profile.customerId,
        })
        ).then(async (response) => {
            if (response && response !== "Failure") {
                await dispatch({ type: SET_QUOTE_DATA, payload: { addresses: response } });
                dataSet = response;
            }
            else throw new Error("Error post LoadAllAddresses > response Failure");
        }).catch(err => {
            logErrorToDatabase("Error post LoadAllAddresses, Error: " + err);
        });
        return dataSet;
    }
}

export const saveAddress = (address: string, latitude: number, longitude: number, addressDetail: any) => {
    return async (dispatch, getState) => {
        let addressId: any = null;
        logEvent('SSP_add_home_content_to_quote', getState().sales.quoteId);
        await postToController(dispatch, 'CreateCustomerAddress', JSON.stringify({
            Latitude: latitude,
            Longitude: longitude,
            AddressLine: address,
            Province: addressDetail.province,
            Suburb: addressDetail.suburb,
            City: addressDetail.city,
            PostalCode: addressDetail.postalCode,
            PersonId: getState().sales.customerId !== "" ? getState().sales.customerId : getState().profile.customerId,
            CountryId: getState().profile.countryId
        })
        ).then(async response => {
            if (response && response !== "Failure") {
                addressId = response.result;
                await dispatch(loadAllAddresses());
            }
            else throw new Error("Error post CreateCustomerAddress > response Failure");
        }).catch(err => {
            logErrorToDatabase("Error post CreateCustomerAddress, Error: " + err);
        });
        return addressId;
    }
}

export const createWebLead = () => {
    return async (dispatch, getState) => {
        dispatch({ type: SALES_CHAT_LOADING_SCREEN_SHOW });

        await postToController(dispatch, 'CreateWebLead', JSON.stringify({
            Email: "",
            ContactNumber: "",
            MobileNumber: getState().sales.cellphoneNumber,
            IdNumber: "",
            FirstName: getState().sales.name,
            Kpcid: getState().profile.countryId == NAM_COUNTRY_ID_NUMBER ? "100097" : "10005",
            Comments: "New quote lead from SSP",
            CountryId: getState().profile.countryId,
            Status: "CLOSED"
        })).then(async (response) => {
            if (response !== null && response !== 'Failure') {
                dispatch({
                    type: SET_QUOTE_DATA, payload: {
                        bucketKey: response.bucketKey,
                        referenceKey: response.leadReference,
                    }
                });
            }
        }).finally(() => {
            dispatch({ type: SALES_CHAT_LOADING_SCREEN_HIDE });
        })
    }
}